// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3B1HT":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18nProvider", function() {
    return 0, _context.I18nProvider;
});
parcelHelpers.export(exports, "useLocale", function() {
    return 0, _context.useLocale;
});
parcelHelpers.export(exports, "useMessageFormatter", function() {
    return 0, _useMessageFormatter.useMessageFormatter;
});
parcelHelpers.export(exports, "useLocalizedStringFormatter", function() {
    return 0, _useLocalizedStringFormatter.useLocalizedStringFormatter;
});
parcelHelpers.export(exports, "useLocalizedStringDictionary", function() {
    return 0, _useLocalizedStringFormatter.useLocalizedStringDictionary;
});
parcelHelpers.export(exports, "useListFormatter", function() {
    return 0, _useListFormatter.useListFormatter;
});
parcelHelpers.export(exports, "useDateFormatter", function() {
    return 0, _useDateFormatter.useDateFormatter;
});
parcelHelpers.export(exports, "useNumberFormatter", function() {
    return 0, _useNumberFormatter.useNumberFormatter;
});
parcelHelpers.export(exports, "useCollator", function() {
    return 0, _useCollator.useCollator;
});
parcelHelpers.export(exports, "useFilter", function() {
    return 0, _useFilter.useFilter;
});
var _context = require("./context");
var _useMessageFormatter = require("./useMessageFormatter");
var _useLocalizedStringFormatter = require("./useLocalizedStringFormatter");
var _useListFormatter = require("./useListFormatter");
var _useDateFormatter = require("./useDateFormatter");
var _useNumberFormatter = require("./useNumberFormatter");
var _useCollator = require("./useCollator");
var _useFilter = require("./useFilter");

},{"./context":"6aOvd","./useMessageFormatter":false,"./useLocalizedStringFormatter":"iU1Gu","./useListFormatter":"aRs2S","./useDateFormatter":"bajxt","./useNumberFormatter":"cArRR","./useCollator":"bKAkm","./useFilter":"b21qn","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"6aOvd":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the locale for the application to all child components.
 */ parcelHelpers.export(exports, "I18nProvider", function() {
    return I18nProvider;
});
/**
 * Returns the current locale and layout direction.
 */ parcelHelpers.export(exports, "useLocale", function() {
    return useLocale;
});
var _utils = require("./utils");
var _useDefaultLocale = require("./useDefaultLocale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var I18nContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function I18nProvider(props) {
    var locale = props.locale, children = props.children;
    var defaultLocale = (0, _useDefaultLocale.useDefaultLocale)();
    var value = locale ? {
        locale: locale,
        direction: (0, _utils.isRTL)(locale) ? "rtl" : "ltr"
    } : defaultLocale;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(I18nContext.Provider, {
        value: value
    }, children);
}
function useLocale() {
    var defaultLocale = (0, _useDefaultLocale.useDefaultLocale)();
    var context = (0, _react.useContext)(I18nContext);
    return context || defaultLocale;
}

},{"./utils":"82ZNp","./useDefaultLocale":"gwtPr","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"82ZNp":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Determines if a locale is read right to left using [Intl.Locale]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale}.
 */ parcelHelpers.export(exports, "isRTL", function() {
    return isRTL;
});
var RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
var RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function isRTL(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        var locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        var textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    var lang = localeString.split("-")[0];
    return RTL_LANGS.has(lang);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"gwtPr":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the locale setting of the browser.
 */ parcelHelpers.export(exports, "getDefaultLocale", function() {
    return getDefaultLocale;
});
/**
 * Returns the current browser/system language, and updates when it changes.
 */ parcelHelpers.export(exports, "useDefaultLocale", function() {
    return useDefaultLocale;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("./utils");
var _react = require("react");
var _ssr = require("@react-aria/ssr");
// Locale passed from server by PackageLocalizationProvider.
var localeSymbol = Symbol.for("react-aria.i18n.locale");
function getDefaultLocale() {
    var locale = typeof window !== "undefined" && window[localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: (0, _utils.isRTL)(locale) ? "rtl" : "ltr"
    };
}
var currentLocale = getDefaultLocale();
var listeners = new Set();
function updateLocale() {
    currentLocale = getDefaultLocale();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var listener = _step.value;
            listener(currentLocale);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function useDefaultLocale() {
    var isSSR = (0, _ssr.useIsSSR)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(currentLocale), 2), defaultLocale = _useState[0], setDefaultLocale = _useState[1];
    (0, _react.useEffect)(function() {
        if (listeners.size === 0) window.addEventListener("languagechange", updateLocale);
        listeners.add(setDefaultLocale);
        return function() {
            listeners.delete(setDefaultLocale);
            if (listeners.size === 0) window.removeEventListener("languagechange", updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}

},{"@swc/helpers/_/_sliced_to_array":"jzEiA","./utils":"82ZNp","react":"lbBKc","@react-aria/ssr":"jaCiN","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"iU1Gu":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a cached LocalizedStringDictionary for the given strings.
 */ parcelHelpers.export(exports, "useLocalizedStringDictionary", function() {
    return useLocalizedStringDictionary;
});
/**
 * Provides localized string formatting for the current locale. Supports interpolating variables,
 * selecting the correct pluralization, and formatting numbers. Automatically updates when the locale changes.
 * @param strings - A mapping of languages to localized strings by key.
 */ parcelHelpers.export(exports, "useLocalizedStringFormatter", function() {
    return useLocalizedStringFormatter;
});
var _string = require("@internationalized/string");
var _context = require("./context");
var _react = require("react");
var cache = new WeakMap();
function getCachedDictionary(strings) {
    var dictionary = cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, _string.LocalizedStringDictionary)(strings);
        cache.set(strings, dictionary);
    }
    return dictionary;
}
function useLocalizedStringDictionary(strings, packageName) {
    return packageName && (0, _string.LocalizedStringDictionary).getGlobalDictionaryForPackage(packageName) || getCachedDictionary(strings);
}
function useLocalizedStringFormatter(strings, packageName) {
    var locale = (0, _context.useLocale)().locale;
    var dictionary = useLocalizedStringDictionary(strings, packageName);
    return (0, _react.useMemo)(function() {
        return new (0, _string.LocalizedStringFormatter)(locale, dictionary);
    }, [
        locale,
        dictionary
    ]);
}

},{"@internationalized/string":"jeczw","./context":"6aOvd","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"jeczw":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalizedStringDictionary", function() {
    return 0, _localizedStringDictionary.LocalizedStringDictionary;
});
parcelHelpers.export(exports, "LocalizedStringFormatter", function() {
    return 0, _localizedStringFormatter.LocalizedStringFormatter;
});
var _localizedStringDictionary = require("./LocalizedStringDictionary");
var _localizedStringFormatter = require("./LocalizedStringFormatter");

},{"./LocalizedStringDictionary":"5l6ro","./LocalizedStringFormatter":"kZnMx","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"5l6ro":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalizedStringDictionary", function() {
    return LocalizedStringDictionary;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var localeSymbol = Symbol.for("react-aria.i18n.locale");
var stringsSymbol = Symbol.for("react-aria.i18n.strings");
var cachedGlobalStrings = undefined;
var LocalizedStringDictionary = /*#__PURE__*/ function() {
    "use strict";
    function LocalizedStringDictionary(messages) {
        var defaultLocale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
        (0, _classCallCheck._)(this, LocalizedStringDictionary);
        // Clone messages so we don't modify the original object.
        // Filter out entries with falsy values which may have been caused by applying optimize-locales-plugin.
        this.strings = Object.fromEntries(Object.entries(messages).filter(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), v = _param[1];
            return v;
        }));
        this.defaultLocale = defaultLocale;
    }
    (0, _createClass._)(LocalizedStringDictionary, [
        {
            /** Returns a localized string for the given key and locale. */ key: "getStringForLocale",
            value: function getStringForLocale(key, locale) {
                var strings = this.getStringsForLocale(locale);
                var string = strings[key];
                if (!string) throw new Error("Could not find intl message ".concat(key, " in ").concat(locale, " locale"));
                return string;
            }
        },
        {
            /** Returns all localized strings for the given locale. */ key: "getStringsForLocale",
            value: function getStringsForLocale1(locale) {
                var strings = this.strings[locale];
                if (!strings) {
                    strings = getStringsForLocale(locale, this.strings, this.defaultLocale);
                    this.strings[locale] = strings;
                }
                return strings;
            }
        }
    ], [
        {
            key: "getGlobalDictionaryForPackage",
            value: function getGlobalDictionaryForPackage(packageName) {
                if (typeof window === "undefined") return null;
                var locale = window[localeSymbol];
                if (cachedGlobalStrings === undefined) {
                    var globalStrings = window[stringsSymbol];
                    if (!globalStrings) return null;
                    cachedGlobalStrings = {};
                    for(var pkg in globalStrings)cachedGlobalStrings[pkg] = new LocalizedStringDictionary((0, _defineProperty._)({}, locale, globalStrings[pkg]), locale);
                }
                var dictionary = cachedGlobalStrings === null || cachedGlobalStrings === void 0 ? void 0 : cachedGlobalStrings[packageName];
                if (!dictionary) throw new Error('Strings for package "'.concat(packageName, '" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.'));
                return dictionary;
            }
        }
    ]);
    return LocalizedStringDictionary;
}();
function getStringsForLocale(locale, strings) {
    var defaultLocale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en-US";
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    var language = getLanguage(locale);
    if (strings[language]) return strings[language];
    for(var key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) // @ts-ignore
    return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_define_property":"5nkYf","@swc/helpers/_/_sliced_to_array":"jzEiA","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"kZnMx":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalizedStringFormatter", function() {
    return LocalizedStringFormatter;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var pluralRulesCache = new Map();
var numberFormatCache = new Map();
var LocalizedStringFormatter = /*#__PURE__*/ function() {
    "use strict";
    function LocalizedStringFormatter(locale, strings) {
        (0, _classCallCheck._)(this, LocalizedStringFormatter);
        this.locale = locale;
        this.strings = strings;
    }
    (0, _createClass._)(LocalizedStringFormatter, [
        {
            /** Formats a localized string for the given key with the provided variables. */ key: "format",
            value: function format(key, variables) {
                var message = this.strings.getStringForLocale(key, this.locale);
                return typeof message === "function" ? message(variables, this) : message;
            }
        },
        {
            key: "plural",
            value: function plural(count, options) {
                var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "cardinal";
                var opt = options["=" + count];
                if (opt) return typeof opt === "function" ? opt() : opt;
                var key = this.locale + ":" + type;
                var pluralRules = pluralRulesCache.get(key);
                if (!pluralRules) {
                    pluralRules = new Intl.PluralRules(this.locale, {
                        type: type
                    });
                    pluralRulesCache.set(key, pluralRules);
                }
                var selected = pluralRules.select(count);
                opt = options[selected] || options.other;
                return typeof opt === "function" ? opt() : opt;
            }
        },
        {
            key: "number",
            value: function number(value) {
                var numberFormat = numberFormatCache.get(this.locale);
                if (!numberFormat) {
                    numberFormat = new Intl.NumberFormat(this.locale);
                    numberFormatCache.set(this.locale, numberFormat);
                }
                return numberFormat.format(value);
            }
        },
        {
            key: "select",
            value: function select(options, value) {
                var opt = options[value] || options.other;
                return typeof opt === "function" ? opt() : opt;
            }
        }
    ]);
    return LocalizedStringFormatter;
}();

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"aRs2S":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized list formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the list formatter for performance.
 * @param options - Formatting options.
 */ parcelHelpers.export(exports, "useListFormatter", function() {
    return useListFormatter;
});
var _context = require("./context");
var _react = require("react");
function useListFormatter() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var locale = (0, _context.useLocale)().locale;
    return (0, _react.useMemo)(function() {
        return new Intl.ListFormat(locale, options);
    }, [
        locale,
        options
    ]);
}

},{"./context":"6aOvd","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"bajxt":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized date formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the date formatter for performance.
 * @param options - Formatting options.
 */ parcelHelpers.export(exports, "useDateFormatter", function() {
    return useDateFormatter;
});
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _context = require("./context");
var _react = require("react");
function useDateFormatter(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, _utils.useDeepMemo)(options !== null && options !== void 0 ? options : {}, isEqual);
    var locale = (0, _context.useLocale)().locale;
    return (0, _react.useMemo)(function() {
        return new (0, _date.DateFormatter)(locale, options);
    }, [
        locale,
        options
    ]);
}
function isEqual(a, b) {
    if (a === b) return true;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = aKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (b[key] !== a[key]) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}

},{"@internationalized/date":"lRVmM","@react-aria/utils":"g2eof","./context":"6aOvd","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"lRVmM":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarDate", function() {
    return 0, _calendarDate.CalendarDate;
});
parcelHelpers.export(exports, "CalendarDateTime", function() {
    return 0, _calendarDate.CalendarDateTime;
});
parcelHelpers.export(exports, "Time", function() {
    return 0, _calendarDate.Time;
});
parcelHelpers.export(exports, "ZonedDateTime", function() {
    return 0, _calendarDate.ZonedDateTime;
});
parcelHelpers.export(exports, "GregorianCalendar", function() {
    return 0, _gregorianCalendar.GregorianCalendar;
});
parcelHelpers.export(exports, "JapaneseCalendar", function() {
    return 0, _japaneseCalendar.JapaneseCalendar;
});
parcelHelpers.export(exports, "BuddhistCalendar", function() {
    return 0, _buddhistCalendar.BuddhistCalendar;
});
parcelHelpers.export(exports, "TaiwanCalendar", function() {
    return 0, _taiwanCalendar.TaiwanCalendar;
});
parcelHelpers.export(exports, "PersianCalendar", function() {
    return 0, _persianCalendar.PersianCalendar;
});
parcelHelpers.export(exports, "IndianCalendar", function() {
    return 0, _indianCalendar.IndianCalendar;
});
parcelHelpers.export(exports, "IslamicCivilCalendar", function() {
    return 0, _islamicCalendar.IslamicCivilCalendar;
});
parcelHelpers.export(exports, "IslamicTabularCalendar", function() {
    return 0, _islamicCalendar.IslamicTabularCalendar;
});
parcelHelpers.export(exports, "IslamicUmalquraCalendar", function() {
    return 0, _islamicCalendar.IslamicUmalquraCalendar;
});
parcelHelpers.export(exports, "HebrewCalendar", function() {
    return 0, _hebrewCalendar.HebrewCalendar;
});
parcelHelpers.export(exports, "EthiopicCalendar", function() {
    return 0, _ethiopicCalendar.EthiopicCalendar;
});
parcelHelpers.export(exports, "EthiopicAmeteAlemCalendar", function() {
    return 0, _ethiopicCalendar.EthiopicAmeteAlemCalendar;
});
parcelHelpers.export(exports, "CopticCalendar", function() {
    return 0, _ethiopicCalendar.CopticCalendar;
});
parcelHelpers.export(exports, "createCalendar", function() {
    return 0, _createCalendar.createCalendar;
});
parcelHelpers.export(exports, "toCalendarDate", function() {
    return 0, _conversion.toCalendarDate;
});
parcelHelpers.export(exports, "toCalendarDateTime", function() {
    return 0, _conversion.toCalendarDateTime;
});
parcelHelpers.export(exports, "toTime", function() {
    return 0, _conversion.toTime;
});
parcelHelpers.export(exports, "toCalendar", function() {
    return 0, _conversion.toCalendar;
});
parcelHelpers.export(exports, "toZoned", function() {
    return 0, _conversion.toZoned;
});
parcelHelpers.export(exports, "toTimeZone", function() {
    return 0, _conversion.toTimeZone;
});
parcelHelpers.export(exports, "toLocalTimeZone", function() {
    return 0, _conversion.toLocalTimeZone;
});
parcelHelpers.export(exports, "fromDate", function() {
    return 0, _conversion.fromDate;
});
parcelHelpers.export(exports, "fromAbsolute", function() {
    return 0, _conversion.fromAbsolute;
});
parcelHelpers.export(exports, "isSameDay", function() {
    return 0, _queries.isSameDay;
});
parcelHelpers.export(exports, "isSameMonth", function() {
    return 0, _queries.isSameMonth;
});
parcelHelpers.export(exports, "isSameYear", function() {
    return 0, _queries.isSameYear;
});
parcelHelpers.export(exports, "isEqualDay", function() {
    return 0, _queries.isEqualDay;
});
parcelHelpers.export(exports, "isEqualMonth", function() {
    return 0, _queries.isEqualMonth;
});
parcelHelpers.export(exports, "isEqualYear", function() {
    return 0, _queries.isEqualYear;
});
parcelHelpers.export(exports, "isToday", function() {
    return 0, _queries.isToday;
});
parcelHelpers.export(exports, "getDayOfWeek", function() {
    return 0, _queries.getDayOfWeek;
});
parcelHelpers.export(exports, "now", function() {
    return 0, _queries.now;
});
parcelHelpers.export(exports, "today", function() {
    return 0, _queries.today;
});
parcelHelpers.export(exports, "getHoursInDay", function() {
    return 0, _queries.getHoursInDay;
});
parcelHelpers.export(exports, "getLocalTimeZone", function() {
    return 0, _queries.getLocalTimeZone;
});
parcelHelpers.export(exports, "startOfMonth", function() {
    return 0, _queries.startOfMonth;
});
parcelHelpers.export(exports, "startOfWeek", function() {
    return 0, _queries.startOfWeek;
});
parcelHelpers.export(exports, "startOfYear", function() {
    return 0, _queries.startOfYear;
});
parcelHelpers.export(exports, "endOfMonth", function() {
    return 0, _queries.endOfMonth;
});
parcelHelpers.export(exports, "endOfWeek", function() {
    return 0, _queries.endOfWeek;
});
parcelHelpers.export(exports, "endOfYear", function() {
    return 0, _queries.endOfYear;
});
parcelHelpers.export(exports, "getMinimumMonthInYear", function() {
    return 0, _queries.getMinimumMonthInYear;
});
parcelHelpers.export(exports, "getMinimumDayInMonth", function() {
    return 0, _queries.getMinimumDayInMonth;
});
parcelHelpers.export(exports, "getWeeksInMonth", function() {
    return 0, _queries.getWeeksInMonth;
});
parcelHelpers.export(exports, "minDate", function() {
    return 0, _queries.minDate;
});
parcelHelpers.export(exports, "maxDate", function() {
    return 0, _queries.maxDate;
});
parcelHelpers.export(exports, "isWeekend", function() {
    return 0, _queries.isWeekend;
});
parcelHelpers.export(exports, "isWeekday", function() {
    return 0, _queries.isWeekday;
});
parcelHelpers.export(exports, "parseDate", function() {
    return 0, _string.parseDate;
});
parcelHelpers.export(exports, "parseDateTime", function() {
    return 0, _string.parseDateTime;
});
parcelHelpers.export(exports, "parseTime", function() {
    return 0, _string.parseTime;
});
parcelHelpers.export(exports, "parseAbsolute", function() {
    return 0, _string.parseAbsolute;
});
parcelHelpers.export(exports, "parseAbsoluteToLocal", function() {
    return 0, _string.parseAbsoluteToLocal;
});
parcelHelpers.export(exports, "parseZonedDateTime", function() {
    return 0, _string.parseZonedDateTime;
});
parcelHelpers.export(exports, "parseDuration", function() {
    return 0, _string.parseDuration;
});
parcelHelpers.export(exports, "DateFormatter", function() {
    return 0, _dateFormatter.DateFormatter;
});
var _calendarDate = require("./CalendarDate");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
var _japaneseCalendar = require("./calendars/JapaneseCalendar");
var _buddhistCalendar = require("./calendars/BuddhistCalendar");
var _taiwanCalendar = require("./calendars/TaiwanCalendar");
var _persianCalendar = require("./calendars/PersianCalendar");
var _indianCalendar = require("./calendars/IndianCalendar");
var _islamicCalendar = require("./calendars/IslamicCalendar");
var _hebrewCalendar = require("./calendars/HebrewCalendar");
var _ethiopicCalendar = require("./calendars/EthiopicCalendar");
var _createCalendar = require("./createCalendar");
var _conversion = require("./conversion");
var _queries = require("./queries");
var _string = require("./string");
var _dateFormatter = require("./DateFormatter");

},{"./CalendarDate":"bo84l","./calendars/GregorianCalendar":"CFsNw","./calendars/JapaneseCalendar":false,"./calendars/BuddhistCalendar":false,"./calendars/TaiwanCalendar":false,"./calendars/PersianCalendar":false,"./calendars/IndianCalendar":false,"./calendars/IslamicCalendar":false,"./calendars/HebrewCalendar":false,"./calendars/EthiopicCalendar":false,"./createCalendar":"4c2fK","./conversion":"aECo1","./queries":"3jJiZ","./string":"dsXT6","./DateFormatter":"3lhNP","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"bo84l":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarDate", function() {
    return CalendarDate;
});
parcelHelpers.export(exports, "Time", function() {
    return Time;
});
parcelHelpers.export(exports, "CalendarDateTime", function() {
    return CalendarDateTime;
});
parcelHelpers.export(exports, "ZonedDateTime", function() {
    return ZonedDateTime;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _manipulation = require("./manipulation");
var _queries = require("./queries");
var _string = require("./string");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
var _conversion = require("./conversion");
function shiftArgs(args) {
    var calendar = typeof args[0] === "object" ? args.shift() : new (0, _gregorianCalendar.GregorianCalendar)();
    var era;
    if (typeof args[0] === "string") era = args.shift();
    else {
        var eras = calendar.getEras();
        era = eras[eras.length - 1];
    }
    var year = args.shift();
    var month = args.shift();
    var day = args.shift();
    return [
        calendar,
        era,
        year,
        month,
        day
    ];
}
var // This prevents TypeScript from allowing other types with the same fields to match.
// i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
// If that behavior is desired, use the AnyCalendarDate interface instead.
// @ts-ignore
_type = /*#__PURE__*/ new WeakMap();
var CalendarDate = /*#__PURE__*/ function() {
    "use strict";
    function CalendarDate() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, CalendarDate);
        (0, _classPrivateFieldInit._)(this, _type, {
            writable: true,
            value: void 0
        });
        var _shiftArgs = (0, _slicedToArray._)(shiftArgs(args), 5), calendar = _shiftArgs[0], era = _shiftArgs[1], year = _shiftArgs[2], month = _shiftArgs[3], day = _shiftArgs[4];
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        (0, _manipulation.constrain)(this);
    }
    (0, _createClass._)(CalendarDate, [
        {
            /** Returns a copy of this date. */ key: "copy",
            value: function copy() {
                if (this.era) return new CalendarDate(this.calendar, this.era, this.year, this.month, this.day);
                else return new CalendarDate(this.calendar, this.year, this.month, this.day);
            }
        },
        {
            /** Returns a new `CalendarDate` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return (0, _manipulation.add)(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDate` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return (0, _manipulation.subtract)(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields) {
                return (0, _manipulation.set)(this, fields);
            }
        },
        {
            /**
   * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                return (0, _manipulation.cycleDate)(this, field, amount, options);
            }
        },
        {
            /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */ key: "toDate",
            value: function toDate(timeZone) {
                return (0, _conversion.toDate)(this, timeZone);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string. */ key: "toString",
            value: function toString() {
                return (0, _string.dateToString)(this);
            }
        },
        {
            /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ key: "compare",
            value: function compare(b) {
                return (0, _queries.compareDate)(this, b);
            }
        }
    ]);
    return CalendarDate;
}();
var // This prevents TypeScript from allowing other types with the same fields to match.
// @ts-ignore
_type1 = /*#__PURE__*/ new WeakMap();
var Time = /*#__PURE__*/ function() {
    "use strict";
    function Time() {
        var hour = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, minute = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, second = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, millisecond = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        (0, _classCallCheck._)(this, Time);
        (0, _classPrivateFieldInit._)(this, _type1, {
            writable: true,
            value: void 0
        });
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
        (0, _manipulation.constrainTime)(this);
    }
    (0, _createClass._)(Time, [
        {
            /** Returns a copy of this time. */ key: "copy",
            value: function copy() {
                return new Time(this.hour, this.minute, this.second, this.millisecond);
            }
        },
        {
            /** Returns a new `Time` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return (0, _manipulation.addTime)(this, duration);
            }
        },
        {
            /** Returns a new `Time` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return (0, _manipulation.subtractTime)(this, duration);
            }
        },
        {
            /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields) {
                return (0, _manipulation.setTime)(this, fields);
            }
        },
        {
            /**
   * Returns a new `Time` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                return (0, _manipulation.cycleTime)(this, field, amount, options);
            }
        },
        {
            /** Converts the time to an ISO 8601 formatted string. */ key: "toString",
            value: function toString() {
                return (0, _string.timeToString)(this);
            }
        },
        {
            /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */ key: "compare",
            value: function compare(b) {
                return (0, _queries.compareTime)(this, b);
            }
        }
    ]);
    return Time;
}();
var // This prevents TypeScript from allowing other types with the same fields to match.
// @ts-ignore
_type2 = /*#__PURE__*/ new WeakMap();
var CalendarDateTime = /*#__PURE__*/ function() {
    "use strict";
    function CalendarDateTime() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, CalendarDateTime);
        (0, _classPrivateFieldInit._)(this, _type2, {
            writable: true,
            value: void 0
        });
        var _shiftArgs = (0, _slicedToArray._)(shiftArgs(args), 5), calendar = _shiftArgs[0], era = _shiftArgs[1], year = _shiftArgs[2], month = _shiftArgs[3], day = _shiftArgs[4];
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        (0, _manipulation.constrain)(this);
    }
    (0, _createClass._)(CalendarDateTime, [
        {
            /** Returns a copy of this date. */ key: "copy",
            value: function copy() {
                if (this.era) return new CalendarDateTime(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
                else return new CalendarDateTime(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
            }
        },
        {
            /** Returns a new `CalendarDateTime` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return (0, _manipulation.add)(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return (0, _manipulation.subtract)(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields) {
                return (0, _manipulation.set)((0, _manipulation.setTime)(this, fields), fields);
            }
        },
        {
            /**
   * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                switch(field){
                    case "era":
                    case "year":
                    case "month":
                    case "day":
                        return (0, _manipulation.cycleDate)(this, field, amount, options);
                    default:
                        return (0, _manipulation.cycleTime)(this, field, amount, options);
                }
            }
        },
        {
            /** Converts the date to a native JavaScript Date object in the given time zone. */ key: "toDate",
            value: function toDate(timeZone, disambiguation) {
                return (0, _conversion.toDate)(this, timeZone, disambiguation);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string. */ key: "toString",
            value: function toString() {
                return (0, _string.dateTimeToString)(this);
            }
        },
        {
            /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ key: "compare",
            value: function compare(b) {
                var res = (0, _queries.compareDate)(this, b);
                if (res === 0) return (0, _queries.compareTime)(this, (0, _conversion.toCalendarDateTime)(b));
                return res;
            }
        }
    ]);
    return CalendarDateTime;
}();
var // This prevents TypeScript from allowing other types with the same fields to match.
// @ts-ignore
_type3 = /*#__PURE__*/ new WeakMap();
var ZonedDateTime = /*#__PURE__*/ function() {
    "use strict";
    function ZonedDateTime() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, ZonedDateTime);
        (0, _classPrivateFieldInit._)(this, _type3, {
            writable: true,
            value: void 0
        });
        var _shiftArgs = (0, _slicedToArray._)(shiftArgs(args), 5), calendar = _shiftArgs[0], era = _shiftArgs[1], year = _shiftArgs[2], month = _shiftArgs[3], day = _shiftArgs[4];
        var timeZone = args.shift();
        var offset = args.shift();
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.timeZone = timeZone;
        this.offset = offset;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        (0, _manipulation.constrain)(this);
    }
    (0, _createClass._)(ZonedDateTime, [
        {
            /** Returns a copy of this date. */ key: "copy",
            value: function copy() {
                if (this.era) return new ZonedDateTime(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
                else return new ZonedDateTime(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
            }
        },
        {
            /** Returns a new `ZonedDateTime` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return (0, _manipulation.addZoned)(this, duration);
            }
        },
        {
            /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return (0, _manipulation.subtractZoned)(this, duration);
            }
        },
        {
            /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields, disambiguation) {
                return (0, _manipulation.setZoned)(this, fields, disambiguation);
            }
        },
        {
            /**
   * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                return (0, _manipulation.cycleZoned)(this, field, amount, options);
            }
        },
        {
            /** Converts the date to a native JavaScript Date object. */ key: "toDate",
            value: function toDate() {
                return (0, _conversion.zonedToDate)(this);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */ key: "toString",
            value: function toString() {
                return (0, _string.zonedDateTimeToString)(this);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string in UTC. */ key: "toAbsoluteString",
            value: function toAbsoluteString() {
                return this.toDate().toISOString();
            }
        },
        {
            /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ key: "compare",
            value: function compare(b) {
                // TODO: Is this a bad idea??
                return this.toDate().getTime() - (0, _conversion.toZoned)(b, this.timeZone).toDate().getTime();
            }
        }
    ]);
    return ZonedDateTime;
}();

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_class_private_field_init":"4Ingl","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_sliced_to_array":"jzEiA","./manipulation":"30Gik","./queries":"3jJiZ","./string":"dsXT6","./calendars/GregorianCalendar":"CFsNw","./conversion":"aECo1","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"30Gik":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", function() {
    return add;
});
parcelHelpers.export(exports, "constrain", function() {
    return constrain;
});
parcelHelpers.export(exports, "invertDuration", function() {
    return invertDuration;
});
parcelHelpers.export(exports, "subtract", function() {
    return subtract;
});
parcelHelpers.export(exports, "set", function() {
    return set;
});
parcelHelpers.export(exports, "setTime", function() {
    return setTime;
});
parcelHelpers.export(exports, "constrainTime", function() {
    return constrainTime;
});
parcelHelpers.export(exports, "addTime", function() {
    return addTime;
});
parcelHelpers.export(exports, "subtractTime", function() {
    return subtractTime;
});
parcelHelpers.export(exports, "cycleDate", function() {
    return cycleDate;
});
parcelHelpers.export(exports, "cycleTime", function() {
    return cycleTime;
});
parcelHelpers.export(exports, "addZoned", function() {
    return addZoned;
});
parcelHelpers.export(exports, "subtractZoned", function() {
    return subtractZoned;
});
parcelHelpers.export(exports, "cycleZoned", function() {
    return cycleZoned;
});
parcelHelpers.export(exports, "setZoned", function() {
    return setZoned;
});
var _conversion = require("./conversion");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
var ONE_HOUR = 3600000;
function add(date, duration) {
    var mutableDate = date.copy();
    var days = "hour" in mutableDate ? addTimeFields(mutableDate, duration) : 0;
    addYears(mutableDate, duration.years || 0);
    if (mutableDate.calendar.balanceYearMonth) mutableDate.calendar.balanceYearMonth(mutableDate, date);
    mutableDate.month += duration.months || 0;
    balanceYearMonth(mutableDate);
    constrainMonthDay(mutableDate);
    mutableDate.day += (duration.weeks || 0) * 7;
    mutableDate.day += duration.days || 0;
    mutableDate.day += days;
    balanceDay(mutableDate);
    if (mutableDate.calendar.balanceDate) mutableDate.calendar.balanceDate(mutableDate);
    // Constrain in case adding ended up with a date outside the valid range for the calendar system.
    // The behavior here is slightly different than when constraining in the `set` function in that
    // we adjust smaller fields to their minimum/maximum values rather than constraining each field
    // individually. This matches the general behavior of `add` vs `set` regarding how fields are balanced.
    if (mutableDate.year < 1) {
        mutableDate.year = 1;
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    var maxYear = mutableDate.calendar.getYearsInEra(mutableDate);
    if (mutableDate.year > maxYear) {
        var _mutableDate_calendar_isInverseEra, _mutableDate_calendar;
        var isInverseEra = (_mutableDate_calendar_isInverseEra = (_mutableDate_calendar = mutableDate.calendar).isInverseEra) === null || _mutableDate_calendar_isInverseEra === void 0 ? void 0 : _mutableDate_calendar_isInverseEra.call(_mutableDate_calendar, mutableDate);
        mutableDate.year = maxYear;
        mutableDate.month = isInverseEra ? 1 : mutableDate.calendar.getMonthsInYear(mutableDate);
        mutableDate.day = isInverseEra ? 1 : mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    if (mutableDate.month < 1) {
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    var maxMonth = mutableDate.calendar.getMonthsInYear(mutableDate);
    if (mutableDate.month > maxMonth) {
        mutableDate.month = maxMonth;
        mutableDate.day = mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    mutableDate.day = Math.max(1, Math.min(mutableDate.calendar.getDaysInMonth(mutableDate), mutableDate.day));
    return mutableDate;
}
function addYears(date, years) {
    var _date_calendar_isInverseEra, _date_calendar;
    if ((_date_calendar_isInverseEra = (_date_calendar = date.calendar).isInverseEra) === null || _date_calendar_isInverseEra === void 0 ? void 0 : _date_calendar_isInverseEra.call(_date_calendar, date)) years = -years;
    date.year += years;
}
function balanceYearMonth(date) {
    while(date.month < 1){
        addYears(date, -1);
        date.month += date.calendar.getMonthsInYear(date);
    }
    var monthsInYear = 0;
    while(date.month > (monthsInYear = date.calendar.getMonthsInYear(date))){
        date.month -= monthsInYear;
        addYears(date, 1);
    }
}
function balanceDay(date) {
    while(date.day < 1){
        date.month--;
        balanceYearMonth(date);
        date.day += date.calendar.getDaysInMonth(date);
    }
    while(date.day > date.calendar.getDaysInMonth(date)){
        date.day -= date.calendar.getDaysInMonth(date);
        date.month++;
        balanceYearMonth(date);
    }
}
function constrainMonthDay(date) {
    date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
    date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}
function constrain(date) {
    if (date.calendar.constrainDate) date.calendar.constrainDate(date);
    date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
    constrainMonthDay(date);
}
function invertDuration(duration) {
    var inverseDuration = {};
    for(var key in duration)if (typeof duration[key] === "number") inverseDuration[key] = -duration[key];
    return inverseDuration;
}
function subtract(date, duration) {
    return add(date, invertDuration(duration));
}
function set(date, fields) {
    var mutableDate = date.copy();
    if (fields.era != null) mutableDate.era = fields.era;
    if (fields.year != null) mutableDate.year = fields.year;
    if (fields.month != null) mutableDate.month = fields.month;
    if (fields.day != null) mutableDate.day = fields.day;
    constrain(mutableDate);
    return mutableDate;
}
function setTime(value, fields) {
    var mutableValue = value.copy();
    if (fields.hour != null) mutableValue.hour = fields.hour;
    if (fields.minute != null) mutableValue.minute = fields.minute;
    if (fields.second != null) mutableValue.second = fields.second;
    if (fields.millisecond != null) mutableValue.millisecond = fields.millisecond;
    constrainTime(mutableValue);
    return mutableValue;
}
function balanceTime(time) {
    time.second += Math.floor(time.millisecond / 1000);
    time.millisecond = nonNegativeMod(time.millisecond, 1000);
    time.minute += Math.floor(time.second / 60);
    time.second = nonNegativeMod(time.second, 60);
    time.hour += Math.floor(time.minute / 60);
    time.minute = nonNegativeMod(time.minute, 60);
    var days = Math.floor(time.hour / 24);
    time.hour = nonNegativeMod(time.hour, 24);
    return days;
}
function constrainTime(time) {
    time.millisecond = Math.max(0, Math.min(time.millisecond, 1000));
    time.second = Math.max(0, Math.min(time.second, 59));
    time.minute = Math.max(0, Math.min(time.minute, 59));
    time.hour = Math.max(0, Math.min(time.hour, 23));
}
function nonNegativeMod(a, b) {
    var result = a % b;
    if (result < 0) result += b;
    return result;
}
function addTimeFields(time, duration) {
    time.hour += duration.hours || 0;
    time.minute += duration.minutes || 0;
    time.second += duration.seconds || 0;
    time.millisecond += duration.milliseconds || 0;
    return balanceTime(time);
}
function addTime(time, duration) {
    var res = time.copy();
    addTimeFields(res, duration);
    return res;
}
function subtractTime(time, duration) {
    return addTime(time, invertDuration(duration));
}
function cycleDate(value, field, amount, options) {
    var mutable = value.copy();
    switch(field){
        case "era":
            {
                var eras = value.calendar.getEras();
                var eraIndex = eras.indexOf(value.era);
                if (eraIndex < 0) throw new Error("Invalid era: " + value.era);
                eraIndex = cycleValue(eraIndex, amount, 0, eras.length - 1, options === null || options === void 0 ? void 0 : options.round);
                mutable.era = eras[eraIndex];
                // Constrain the year and other fields within the era, so the era doesn't change when we balance below.
                constrain(mutable);
                break;
            }
        case "year":
            var _mutable_calendar_isInverseEra, _mutable_calendar;
            if ((_mutable_calendar_isInverseEra = (_mutable_calendar = mutable.calendar).isInverseEra) === null || _mutable_calendar_isInverseEra === void 0 ? void 0 : _mutable_calendar_isInverseEra.call(_mutable_calendar, mutable)) amount = -amount;
            // The year field should not cycle within the era as that can cause weird behavior affecting other fields.
            // We need to also allow values < 1 so that decrementing goes to the previous era. If we get -Infinity back
            // we know we wrapped around after reaching 9999 (the maximum), so set the year back to 1.
            mutable.year = cycleValue(value.year, amount, -Infinity, 9999, options === null || options === void 0 ? void 0 : options.round);
            if (mutable.year === -Infinity) mutable.year = 1;
            if (mutable.calendar.balanceYearMonth) mutable.calendar.balanceYearMonth(mutable, value);
            break;
        case "month":
            mutable.month = cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        case "day":
            mutable.day = cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    if (value.calendar.balanceDate) value.calendar.balanceDate(mutable);
    constrain(mutable);
    return mutable;
}
function cycleTime(value, field, amount, options) {
    var mutable = value.copy();
    switch(field){
        case "hour":
            {
                var hours = value.hour;
                var min = 0;
                var max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    var isPM = hours >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                mutable.hour = cycleValue(hours, amount, min, max, options === null || options === void 0 ? void 0 : options.round);
                break;
            }
        case "minute":
            mutable.minute = cycleValue(value.minute, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "second":
            mutable.second = cycleValue(value.second, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "millisecond":
            mutable.millisecond = cycleValue(value.millisecond, amount, 0, 999, options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    return mutable;
}
function cycleValue(value, amount, min, max) {
    var round = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (round) {
        value += Math.sign(amount);
        if (value < min) value = max;
        var div = Math.abs(amount);
        if (amount > 0) value = Math.ceil(value / div) * div;
        else value = Math.floor(value / div) * div;
        if (value > max) value = min;
    } else {
        value += amount;
        if (value < min) value = max - (min - value - 1);
        else if (value > max) value = min + (value - max - 1);
    }
    return value;
}
function addZoned(dateTime, duration) {
    var ms;
    if (duration.years != null && duration.years !== 0 || duration.months != null && duration.months !== 0 || duration.weeks != null && duration.weeks !== 0 || duration.days != null && duration.days !== 0) {
        var res = add((0, _conversion.toCalendarDateTime)(dateTime), {
            years: duration.years,
            months: duration.months,
            weeks: duration.weeks,
            days: duration.days
        });
        // Changing the date may change the timezone offset, so we need to recompute
        // using the 'compatible' disambiguation.
        ms = (0, _conversion.toAbsolute)(res, dateTime.timeZone);
    } else // Otherwise, preserve the offset of the original date.
    ms = (0, _conversion.epochFromDate)(dateTime) - dateTime.offset;
    // Perform time manipulation in milliseconds rather than on the original time fields to account for DST.
    // For example, adding one hour during a DST transition may result in the hour field staying the same or
    // skipping an hour. This results in the offset field changing value instead of the specified field.
    ms += duration.milliseconds || 0;
    ms += (duration.seconds || 0) * 1000;
    ms += (duration.minutes || 0) * 60000;
    ms += (duration.hours || 0) * 3600000;
    var res1 = (0, _conversion.fromAbsolute)(ms, dateTime.timeZone);
    return (0, _conversion.toCalendar)(res1, dateTime.calendar);
}
function subtractZoned(dateTime, duration) {
    return addZoned(dateTime, invertDuration(duration));
}
function cycleZoned(dateTime, field, amount, options) {
    // For date fields, we want the time to remain consistent and the UTC offset to potentially change to account for DST changes.
    // For time fields, we want the time to change by the amount given. This may result in the hour field staying the same, but the UTC
    // offset changing in the case of a backward DST transition, or skipping an hour in the case of a forward DST transition.
    switch(field){
        case "hour":
            {
                var min = 0;
                var max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    var isPM = dateTime.hour >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                // The minimum and maximum hour may be affected by daylight saving time.
                // For example, it might jump forward at midnight, and skip 1am.
                // Or it might end at midnight and repeat the 11pm hour. To handle this, we get
                // the possible absolute times for the min and max, and find the maximum range
                // that is within the current day.
                var plainDateTime = (0, _conversion.toCalendarDateTime)(dateTime);
                var minDate = (0, _conversion.toCalendar)(setTime(plainDateTime, {
                    hour: min
                }), new (0, _gregorianCalendar.GregorianCalendar)());
                var minAbsolute = [
                    (0, _conversion.toAbsolute)(minDate, dateTime.timeZone, "earlier"),
                    (0, _conversion.toAbsolute)(minDate, dateTime.timeZone, "later")
                ].filter(function(ms) {
                    return (0, _conversion.fromAbsolute)(ms, dateTime.timeZone).day === minDate.day;
                })[0];
                var maxDate = (0, _conversion.toCalendar)(setTime(plainDateTime, {
                    hour: max
                }), new (0, _gregorianCalendar.GregorianCalendar)());
                var maxAbsolute = [
                    (0, _conversion.toAbsolute)(maxDate, dateTime.timeZone, "earlier"),
                    (0, _conversion.toAbsolute)(maxDate, dateTime.timeZone, "later")
                ].filter(function(ms) {
                    return (0, _conversion.fromAbsolute)(ms, dateTime.timeZone).day === maxDate.day;
                }).pop();
                // Since hours may repeat, we need to operate on the absolute time in milliseconds.
                // This is done in hours from the Unix epoch so that cycleValue works correctly,
                // and then converted back to milliseconds.
                var ms = (0, _conversion.epochFromDate)(dateTime) - dateTime.offset;
                var hours = Math.floor(ms / ONE_HOUR);
                var remainder = ms % ONE_HOUR;
                ms = cycleValue(hours, amount, Math.floor(minAbsolute / ONE_HOUR), Math.floor(maxAbsolute / ONE_HOUR), options === null || options === void 0 ? void 0 : options.round) * ONE_HOUR + remainder;
                // Now compute the new timezone offset, and convert the absolute time back to local time.
                return (0, _conversion.toCalendar)((0, _conversion.fromAbsolute)(ms, dateTime.timeZone), dateTime.calendar);
            }
        case "minute":
        case "second":
        case "millisecond":
            // @ts-ignore
            return cycleTime(dateTime, field, amount, options);
        case "era":
        case "year":
        case "month":
        case "day":
            {
                var res = cycleDate((0, _conversion.toCalendarDateTime)(dateTime), field, amount, options);
                var ms1 = (0, _conversion.toAbsolute)(res, dateTime.timeZone);
                return (0, _conversion.toCalendar)((0, _conversion.fromAbsolute)(ms1, dateTime.timeZone), dateTime.calendar);
            }
        default:
            throw new Error("Unsupported field " + field);
    }
}
function setZoned(dateTime, fields, disambiguation) {
    // Set the date/time fields, and recompute the UTC offset to account for DST changes.
    // We also need to validate by converting back to a local time in case hours are skipped during forward DST transitions.
    var plainDateTime = (0, _conversion.toCalendarDateTime)(dateTime);
    var res = setTime(set(plainDateTime, fields), fields);
    // If the resulting plain date time values are equal, return the original time.
    // We don't want to change the offset when setting the time to the same value.
    if (res.compare(plainDateTime) === 0) return dateTime;
    var ms = (0, _conversion.toAbsolute)(res, dateTime.timeZone, disambiguation);
    return (0, _conversion.toCalendar)((0, _conversion.fromAbsolute)(ms, dateTime.timeZone), dateTime.calendar);
}

},{"./conversion":"aECo1","./calendars/GregorianCalendar":"CFsNw","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"aECo1":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epochFromDate", function() {
    return epochFromDate;
});
parcelHelpers.export(exports, "getTimeZoneOffset", function() {
    return getTimeZoneOffset;
});
parcelHelpers.export(exports, "possibleAbsolutes", function() {
    return possibleAbsolutes;
});
parcelHelpers.export(exports, "toAbsolute", function() {
    return toAbsolute;
});
parcelHelpers.export(exports, "toDate", function() {
    return toDate;
});
/**
 * Takes a Unix epoch (milliseconds since 1970) and converts it to the provided time zone.
 */ parcelHelpers.export(exports, "fromAbsolute", function() {
    return fromAbsolute;
});
/**
 * Takes a `Date` object and converts it to the provided time zone.
 */ parcelHelpers.export(exports, "fromDate", function() {
    return fromDate;
});
parcelHelpers.export(exports, "fromDateToLocal", function() {
    return fromDateToLocal;
});
/** Converts a value with date components such as a `CalendarDateTime` or `ZonedDateTime` into a `CalendarDate`. */ parcelHelpers.export(exports, "toCalendarDate", function() {
    return toCalendarDate;
});
parcelHelpers.export(exports, "toDateFields", function() {
    return toDateFields;
});
parcelHelpers.export(exports, "toTimeFields", function() {
    return toTimeFields;
});
/**
 * Converts a date value to a `CalendarDateTime`. An optional `Time` value can be passed to set the time
 * of the resulting value, otherwise it will default to midnight.
 */ parcelHelpers.export(exports, "toCalendarDateTime", function() {
    return toCalendarDateTime;
});
/** Extracts the time components from a value containing a date and time. */ parcelHelpers.export(exports, "toTime", function() {
    return toTime;
});
/** Converts a date from one calendar system to another. */ parcelHelpers.export(exports, "toCalendar", function() {
    return toCalendar;
});
/**
 * Converts a date value to a `ZonedDateTime` in the provided time zone. The `disambiguation` option can be set
 * to control how values that fall on daylight saving time changes are interpreted.
 */ parcelHelpers.export(exports, "toZoned", function() {
    return toZoned;
});
parcelHelpers.export(exports, "zonedToDate", function() {
    return zonedToDate;
});
/** Converts a `ZonedDateTime` from one time zone to another. */ parcelHelpers.export(exports, "toTimeZone", function() {
    return toTimeZone;
});
/** Converts the given `ZonedDateTime` into the user's local time zone. */ parcelHelpers.export(exports, "toLocalTimeZone", function() {
    return toLocalTimeZone;
});
var _calendarDate = require("./CalendarDate");
var _manipulation = require("./manipulation");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
var _queries = require("./queries");
function epochFromDate(date) {
    date = toCalendar(date, new (0, _gregorianCalendar.GregorianCalendar)());
    var year = (0, _gregorianCalendar.getExtendedYear)(date.era, date.year);
    return epochFromParts(year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}
function epochFromParts(year, month, day, hour, minute, second, millisecond) {
    // Note: Date.UTC() interprets one and two-digit years as being in the
    // 20th century, so don't use it
    var date = new Date();
    date.setUTCHours(hour, minute, second, millisecond);
    date.setUTCFullYear(year, month - 1, day);
    return date.getTime();
}
function getTimeZoneOffset(ms, timeZone) {
    // Fast path for UTC.
    if (timeZone === "UTC") return 0;
    // Fast path: for local timezone after 1970, use native Date.
    if (ms > 0 && timeZone === (0, _queries.getLocalTimeZone)()) return new Date(ms).getTimezoneOffset() * -60000;
    var _getTimeZoneParts = getTimeZoneParts(ms, timeZone), year = _getTimeZoneParts.year, month = _getTimeZoneParts.month, day = _getTimeZoneParts.day, hour = _getTimeZoneParts.hour, minute = _getTimeZoneParts.minute, second = _getTimeZoneParts.second;
    var utc = epochFromParts(year, month, day, hour, minute, second, 0);
    return utc - Math.floor(ms / 1000) * 1000;
}
var formattersByTimeZone = new Map();
function getTimeZoneParts(ms, timeZone) {
    var formatter = formattersByTimeZone.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            hour12: false,
            era: "short",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        });
        formattersByTimeZone.set(timeZone, formatter);
    }
    var parts = formatter.formatToParts(new Date(ms));
    var namedParts = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            if (part.type !== "literal") namedParts[part.type] = part.value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
        year: namedParts.era === "BC" || namedParts.era === "B" ? -namedParts.year + 1 : +namedParts.year,
        month: +namedParts.month,
        day: +namedParts.day,
        hour: namedParts.hour === "24" ? 0 : +namedParts.hour,
        minute: +namedParts.minute,
        second: +namedParts.second
    };
}
var DAYMILLIS = 86400000;
function possibleAbsolutes(date, timeZone) {
    var ms = epochFromDate(date);
    var earlier = ms - getTimeZoneOffset(ms - DAYMILLIS, timeZone);
    var later = ms - getTimeZoneOffset(ms + DAYMILLIS, timeZone);
    return getValidWallTimes(date, timeZone, earlier, later);
}
function getValidWallTimes(date, timeZone, earlier, later) {
    var found = earlier === later ? [
        earlier
    ] : [
        earlier,
        later
    ];
    return found.filter(function(absolute) {
        return isValidWallTime(date, timeZone, absolute);
    });
}
function isValidWallTime(date, timeZone, absolute) {
    var parts = getTimeZoneParts(absolute, timeZone);
    return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}
function toAbsolute(date, timeZone) {
    var disambiguation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "compatible";
    var dateTime = toCalendarDateTime(date);
    // Fast path: if the time zone is UTC, use native Date.
    if (timeZone === "UTC") return epochFromDate(dateTime);
    // Fast path: if the time zone is the local timezone and disambiguation is compatible, use native Date.
    if (timeZone === (0, _queries.getLocalTimeZone)() && disambiguation === "compatible") {
        dateTime = toCalendar(dateTime, new (0, _gregorianCalendar.GregorianCalendar)());
        // Don't use Date constructor here because two-digit years are interpreted in the 20th century.
        var _$date = new Date();
        var year = (0, _gregorianCalendar.getExtendedYear)(dateTime.era, dateTime.year);
        _$date.setFullYear(year, dateTime.month - 1, dateTime.day);
        _$date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
        return _$date.getTime();
    }
    var ms = epochFromDate(dateTime);
    var offsetBefore = getTimeZoneOffset(ms - DAYMILLIS, timeZone);
    var offsetAfter = getTimeZoneOffset(ms + DAYMILLIS, timeZone);
    var valid = getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);
    if (valid.length === 1) return valid[0];
    if (valid.length > 1) switch(disambiguation){
        // 'compatible' means 'earlier' for "fall back" transitions
        case "compatible":
        case "earlier":
            return valid[0];
        case "later":
            return valid[valid.length - 1];
        case "reject":
            throw new RangeError("Multiple possible absolute times found");
    }
    switch(disambiguation){
        case "earlier":
            return Math.min(ms - offsetBefore, ms - offsetAfter);
        // 'compatible' means 'later' for "spring forward" transitions
        case "compatible":
        case "later":
            return Math.max(ms - offsetBefore, ms - offsetAfter);
        case "reject":
            throw new RangeError("No such absolute time found");
    }
}
function toDate(dateTime, timeZone) {
    var disambiguation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "compatible";
    return new Date(toAbsolute(dateTime, timeZone, disambiguation));
}
function fromAbsolute(ms, timeZone) {
    var offset = getTimeZoneOffset(ms, timeZone);
    var date = new Date(ms + offset);
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth() + 1;
    var day = date.getUTCDate();
    var hour = date.getUTCHours();
    var minute = date.getUTCMinutes();
    var second = date.getUTCSeconds();
    var millisecond = date.getUTCMilliseconds();
    return new (0, _calendarDate.ZonedDateTime)(year, month, day, timeZone, offset, hour, minute, second, millisecond);
}
function fromDate(date, timeZone) {
    return fromAbsolute(date.getTime(), timeZone);
}
function fromDateToLocal(date) {
    return fromDate(date, (0, _queries.getLocalTimeZone)());
}
function toCalendarDate(dateTime) {
    return new (0, _calendarDate.CalendarDate)(dateTime.calendar, dateTime.era, dateTime.year, dateTime.month, dateTime.day);
}
function toDateFields(date) {
    return {
        era: date.era,
        year: date.year,
        month: date.month,
        day: date.day
    };
}
function toTimeFields(date) {
    return {
        hour: date.hour,
        minute: date.minute,
        second: date.second,
        millisecond: date.millisecond
    };
}
function toCalendarDateTime(date, time) {
    var hour = 0, minute = 0, second = 0, millisecond = 0;
    var ref;
    if ("timeZone" in date) ref = date, hour = ref.hour, minute = ref.minute, second = ref.second, millisecond = ref.millisecond, ref;
    else if ("hour" in date && !time) return date;
    var ref1;
    if (time) ref1 = time, hour = ref1.hour, minute = ref1.minute, second = ref1.second, millisecond = ref1.millisecond, ref1;
    return new (0, _calendarDate.CalendarDateTime)(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
function toTime(dateTime) {
    return new (0, _calendarDate.Time)(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
}
function toCalendar(date, calendar) {
    if (date.calendar.identifier === calendar.identifier) return date;
    var calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
    var copy = date.copy();
    copy.calendar = calendar;
    copy.era = calendarDate.era;
    copy.year = calendarDate.year;
    copy.month = calendarDate.month;
    copy.day = calendarDate.day;
    (0, _manipulation.constrain)(copy);
    return copy;
}
function toZoned(date, timeZone, disambiguation) {
    if (date instanceof (0, _calendarDate.ZonedDateTime)) {
        if (date.timeZone === timeZone) return date;
        return toTimeZone(date, timeZone);
    }
    var ms = toAbsolute(date, timeZone, disambiguation);
    return fromAbsolute(ms, timeZone);
}
function zonedToDate(date) {
    var ms = epochFromDate(date) - date.offset;
    return new Date(ms);
}
function toTimeZone(date, timeZone) {
    var ms = epochFromDate(date) - date.offset;
    return toCalendar(fromAbsolute(ms, timeZone), date.calendar);
}
function toLocalTimeZone(date) {
    return toTimeZone(date, (0, _queries.getLocalTimeZone)());
}

},{"./CalendarDate":"bo84l","./manipulation":"30Gik","./calendars/GregorianCalendar":"CFsNw","./queries":"3jJiZ","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"CFsNw":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gregorianToJulianDay", function() {
    return gregorianToJulianDay;
});
parcelHelpers.export(exports, "isLeapYear", function() {
    return isLeapYear;
});
parcelHelpers.export(exports, "getExtendedYear", function() {
    return getExtendedYear;
});
parcelHelpers.export(exports, "fromExtendedYear", function() {
    return fromExtendedYear;
});
parcelHelpers.export(exports, "GregorianCalendar", function() {
    return GregorianCalendar;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _calendarDate = require("../CalendarDate");
var _utils = require("../utils");
var EPOCH = 1721426; // 001/01/03 Julian C.E.
function gregorianToJulianDay(era, year, month, day) {
    year = getExtendedYear(era, year);
    var y1 = year - 1;
    var monthOffset = -2;
    if (month <= 2) monthOffset = 0;
    else if (isLeapYear(year)) monthOffset = -1;
    return EPOCH - 1 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}
function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function getExtendedYear(era, year) {
    return era === "BC" ? 1 - year : year;
}
function fromExtendedYear(year) {
    var era = "AD";
    if (year <= 0) {
        era = "BC";
        year = 1 - year;
    }
    return [
        era,
        year
    ];
}
var daysInMonth = {
    standard: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    leapyear: [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ]
};
var GregorianCalendar = /*#__PURE__*/ function() {
    "use strict";
    function GregorianCalendar() {
        (0, _classCallCheck._)(this, GregorianCalendar);
        this.identifier = "gregory";
    }
    (0, _createClass._)(GregorianCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var jd0 = jd;
                var depoch = jd0 - EPOCH;
                var quadricent = Math.floor(depoch / 146097);
                var dqc = (0, _utils.mod)(depoch, 146097);
                var cent = Math.floor(dqc / 36524);
                var dcent = (0, _utils.mod)(dqc, 36524);
                var quad = Math.floor(dcent / 1461);
                var dquad = (0, _utils.mod)(dcent, 1461);
                var yindex = Math.floor(dquad / 365);
                var extendedYear = quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0);
                var _fromExtendedYear = (0, _slicedToArray._)(fromExtendedYear(extendedYear), 2), era = _fromExtendedYear[0], year = _fromExtendedYear[1];
                var yearDay = jd0 - gregorianToJulianDay(era, year, 1, 1);
                var leapAdj = 2;
                if (jd0 < gregorianToJulianDay(era, year, 3, 1)) leapAdj = 0;
                else if (isLeapYear(year)) leapAdj = 1;
                var month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
                var day = jd0 - gregorianToJulianDay(era, year, month, 1) + 1;
                return new (0, _calendarDate.CalendarDate)(era, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return gregorianToJulianDay(date.era, date.year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return daysInMonth[isLeapYear(date.year) ? "leapyear" : "standard"][date.month - 1];
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            key: "getMonthsInYear",
            value: function getMonthsInYear(date) {
                return 12;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return isLeapYear(date.year) ? 366 : 365;
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                return 9999;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "BC",
                    "AD"
                ];
            }
        },
        {
            key: "isInverseEra",
            value: function isInverseEra(date) {
                return date.era === "BC";
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                if (date.year <= 0) {
                    date.era = date.era === "BC" ? "AD" : "BC";
                    date.year = 1 - date.year;
                }
            }
        }
    ]);
    return GregorianCalendar;
}();

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_sliced_to_array":"jzEiA","../CalendarDate":"bo84l","../utils":"8Jhao","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"8Jhao":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mod", function() {
    return mod;
});
parcelHelpers.export(exports, "copy", function() {
    return copy;
});
parcelHelpers.export(exports, "copyDateTime", function() {
    return copyDateTime;
});
var _calendarDate = require("./CalendarDate");
function mod(amount, numerator) {
    return amount - numerator * Math.floor(amount / numerator);
}
function copy(date) {
    if (date.era) return new (0, _calendarDate.CalendarDate)(date.calendar, date.era, date.year, date.month, date.day);
    else return new (0, _calendarDate.CalendarDate)(date.calendar, date.year, date.month, date.day);
}
function copyDateTime(date) {
    if (date.era) return new (0, _calendarDate.CalendarDateTime)(date.calendar, date.era, date.year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
    else return new (0, _calendarDate.CalendarDateTime)(date.calendar, date.year, date.month, date.day, date.hour, date.minute, date.second);
}

},{"./CalendarDate":"bo84l","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"3jJiZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Returns whether the given dates occur on the same day, regardless of the time or calendar system. */ parcelHelpers.export(exports, "isSameDay", function() {
    return isSameDay;
});
/** Returns whether the given dates occur in the same month, using the calendar system of the first date. */ parcelHelpers.export(exports, "isSameMonth", function() {
    return isSameMonth;
});
/** Returns whether the given dates occur in the same year, using the calendar system of the first date. */ parcelHelpers.export(exports, "isSameYear", function() {
    return isSameYear;
});
/** Returns whether the given dates occur on the same day, and are of the same calendar system. */ parcelHelpers.export(exports, "isEqualDay", function() {
    return isEqualDay;
});
/** Returns whether the given dates occur in the same month, and are of the same calendar system. */ parcelHelpers.export(exports, "isEqualMonth", function() {
    return isEqualMonth;
});
/** Returns whether the given dates occur in the same year, and are of the same calendar system. */ parcelHelpers.export(exports, "isEqualYear", function() {
    return isEqualYear;
});
/** Returns whether the date is today in the given time zone. */ parcelHelpers.export(exports, "isToday", function() {
    return isToday;
});
/**
 * Returns the day of week for the given date and locale. Days are numbered from zero to six,
 * where zero is the first day of the week in the given locale. For example, in the United States,
 * the first day of the week is Sunday, but in France it is Monday.
 */ parcelHelpers.export(exports, "getDayOfWeek", function() {
    return getDayOfWeek;
});
/** Returns the current time in the given time zone. */ parcelHelpers.export(exports, "now", function() {
    return now;
});
/** Returns today's date in the given time zone. */ parcelHelpers.export(exports, "today", function() {
    return today;
});
parcelHelpers.export(exports, "compareDate", function() {
    return compareDate;
});
parcelHelpers.export(exports, "compareTime", function() {
    return compareTime;
});
/**
 * Returns the number of hours in the given date and time zone.
 * Usually this is 24, but it could be 23 or 25 if the date is on a daylight saving transition.
 */ parcelHelpers.export(exports, "getHoursInDay", function() {
    return getHoursInDay;
});
/** Returns the time zone identifier for the current user. */ parcelHelpers.export(exports, "getLocalTimeZone", function() {
    return getLocalTimeZone;
});
parcelHelpers.export(exports, "startOfMonth", function() {
    return startOfMonth;
});
parcelHelpers.export(exports, "endOfMonth", function() {
    return endOfMonth;
});
parcelHelpers.export(exports, "startOfYear", function() {
    return startOfYear;
});
parcelHelpers.export(exports, "endOfYear", function() {
    return endOfYear;
});
parcelHelpers.export(exports, "getMinimumMonthInYear", function() {
    return getMinimumMonthInYear;
});
parcelHelpers.export(exports, "getMinimumDayInMonth", function() {
    return getMinimumDayInMonth;
});
parcelHelpers.export(exports, "startOfWeek", function() {
    return startOfWeek;
});
parcelHelpers.export(exports, "endOfWeek", function() {
    return endOfWeek;
});
/** Returns the number of weeks in the given month and locale. */ parcelHelpers.export(exports, "getWeeksInMonth", function() {
    return getWeeksInMonth;
});
/** Returns the lesser of the two provider dates. */ parcelHelpers.export(exports, "minDate", function() {
    return minDate;
});
/** Returns the greater of the two provider dates. */ parcelHelpers.export(exports, "maxDate", function() {
    return maxDate;
});
/** Returns whether the given date is on a weekend in the given locale. */ parcelHelpers.export(exports, "isWeekend", function() {
    return isWeekend;
});
/** Returns whether the given date is on a weekday in the given locale. */ parcelHelpers.export(exports, "isWeekday", function() {
    return isWeekday;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _conversion = require("./conversion");
var _weekStartData = require("./weekStartData");
function isSameDay(a, b) {
    b = (0, _conversion.toCalendar)(b, a.calendar);
    return a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function isSameMonth(a, b) {
    b = (0, _conversion.toCalendar)(b, a.calendar);
    // In the Japanese calendar, months can span multiple eras/years, so only compare the first of the month.
    a = startOfMonth(a);
    b = startOfMonth(b);
    return a.era === b.era && a.year === b.year && a.month === b.month;
}
function isSameYear(a, b) {
    b = (0, _conversion.toCalendar)(b, a.calendar);
    a = startOfYear(a);
    b = startOfYear(b);
    return a.era === b.era && a.year === b.year;
}
function isEqualDay(a, b) {
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function isEqualMonth(a, b) {
    a = startOfMonth(a);
    b = startOfMonth(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month;
}
function isEqualYear(a, b) {
    a = startOfYear(a);
    b = startOfYear(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year;
}
function isToday(date, timeZone) {
    return isSameDay(date, today(timeZone));
}
function getDayOfWeek(date, locale) {
    var julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    var dayOfWeek = Math.ceil(julian + 1 - getWeekStart(locale)) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    return dayOfWeek;
}
function now(timeZone) {
    return (0, _conversion.fromAbsolute)(Date.now(), timeZone);
}
function today(timeZone) {
    return (0, _conversion.toCalendarDate)(now(timeZone));
}
function compareDate(a, b) {
    return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
function compareTime(a, b) {
    return timeToMs(a) - timeToMs(b);
}
function timeToMs(a) {
    return a.hour * 3600000 + a.minute * 60000 + a.second * 1000 + a.millisecond;
}
function getHoursInDay(a, timeZone) {
    var ms = (0, _conversion.toAbsolute)(a, timeZone);
    var tomorrow = a.add({
        days: 1
    });
    var tomorrowMs = (0, _conversion.toAbsolute)(tomorrow, timeZone);
    return (tomorrowMs - ms) / 3600000;
}
var localTimeZone = null;
function getLocalTimeZone() {
    // TODO: invalidate this somehow?
    if (localTimeZone == null) localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return localTimeZone;
}
function startOfMonth(date) {
    // Use `subtract` instead of `set` so we don't get constrained in an era.
    return date.subtract({
        days: date.day - 1
    });
}
function endOfMonth(date) {
    return date.add({
        days: date.calendar.getDaysInMonth(date) - date.day
    });
}
function startOfYear(date) {
    return startOfMonth(date.subtract({
        months: date.month - 1
    }));
}
function endOfYear(date) {
    return endOfMonth(date.add({
        months: date.calendar.getMonthsInYear(date) - date.month
    }));
}
function getMinimumMonthInYear(date) {
    if (date.calendar.getMinimumMonthInYear) return date.calendar.getMinimumMonthInYear(date);
    return 1;
}
function getMinimumDayInMonth(date) {
    if (date.calendar.getMinimumDayInMonth) return date.calendar.getMinimumDayInMonth(date);
    return 1;
}
function startOfWeek(date, locale) {
    var dayOfWeek = getDayOfWeek(date, locale);
    return date.subtract({
        days: dayOfWeek
    });
}
function endOfWeek(date, locale) {
    return startOfWeek(date, locale).add({
        days: 6
    });
}
var cachedRegions = new Map();
function getRegion(locale) {
    // If the Intl.Locale API is available, use it to get the region for the locale.
    // @ts-ignore
    if (Intl.Locale) {
        // Constructing an Intl.Locale is expensive, so cache the result.
        var region = cachedRegions.get(locale);
        if (!region) {
            // @ts-ignore
            region = new Intl.Locale(locale).maximize().region;
            if (region) cachedRegions.set(locale, region);
        }
        return region;
    }
    // If not, just try splitting the string.
    // If the second part of the locale string is 'u',
    // then this is a unicode extension, so ignore it.
    // Otherwise, it should be the region.
    var part = locale.split("-")[1];
    return part === "u" ? undefined : part;
}
function getWeekStart(locale) {
    // TODO: use Intl.Locale for this once browsers support the weekInfo property
    // https://github.com/tc39/proposal-intl-locale-info
    var region = getRegion(locale);
    return region ? (0, _weekStartData.weekStartData)[region] || 0 : 0;
}
function getWeeksInMonth(date, locale) {
    var days = date.calendar.getDaysInMonth(date);
    return Math.ceil((getDayOfWeek(startOfMonth(date), locale) + days) / 7);
}
function minDate(a, b) {
    if (a && b) return a.compare(b) <= 0 ? a : b;
    return a || b;
}
function maxDate(a, b) {
    if (a && b) return a.compare(b) >= 0 ? a : b;
    return a || b;
}
var WEEKEND_DATA = {
    AF: [
        4,
        5
    ],
    AE: [
        5,
        6
    ],
    BH: [
        5,
        6
    ],
    DZ: [
        5,
        6
    ],
    EG: [
        5,
        6
    ],
    IL: [
        5,
        6
    ],
    IQ: [
        5,
        6
    ],
    IR: [
        5,
        5
    ],
    JO: [
        5,
        6
    ],
    KW: [
        5,
        6
    ],
    LY: [
        5,
        6
    ],
    OM: [
        5,
        6
    ],
    QA: [
        5,
        6
    ],
    SA: [
        5,
        6
    ],
    SD: [
        5,
        6
    ],
    SY: [
        5,
        6
    ],
    YE: [
        5,
        6
    ]
};
function isWeekend(date, locale) {
    var julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    var dayOfWeek = Math.ceil(julian + 1) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    var region = getRegion(locale);
    // Use Intl.Locale for this once weekInfo is supported.
    // https://github.com/tc39/proposal-intl-locale-info
    var _ref = (0, _slicedToArray._)(WEEKEND_DATA[region] || [
        6,
        0
    ], 2), start = _ref[0], end = _ref[1];
    return dayOfWeek === start || dayOfWeek === end;
}
function isWeekday(date, locale) {
    return !isWeekend(date, locale);
}

},{"@swc/helpers/_/_sliced_to_array":"jzEiA","./conversion":"aECo1","./weekStartData":"5Zl7d","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"5Zl7d":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Data from https://github.com/unicode-cldr/cldr-core/blob/master/supplemental/weekData.json
// Locales starting on Sunday have been removed for compression.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "weekStartData", function() {
    return weekStartData;
});
var weekStartData = {
    "001": 1,
    AD: 1,
    AE: 6,
    AF: 6,
    AI: 1,
    AL: 1,
    AM: 1,
    AN: 1,
    AR: 1,
    AT: 1,
    AU: 1,
    AX: 1,
    AZ: 1,
    BA: 1,
    BE: 1,
    BG: 1,
    BH: 6,
    BM: 1,
    BN: 1,
    BY: 1,
    CH: 1,
    CL: 1,
    CM: 1,
    CN: 1,
    CR: 1,
    CY: 1,
    CZ: 1,
    DE: 1,
    DJ: 6,
    DK: 1,
    DZ: 6,
    EC: 1,
    EE: 1,
    EG: 6,
    ES: 1,
    FI: 1,
    FJ: 1,
    FO: 1,
    FR: 1,
    GB: 1,
    GE: 1,
    GF: 1,
    GP: 1,
    GR: 1,
    HR: 1,
    HU: 1,
    IE: 1,
    IQ: 6,
    IR: 6,
    IS: 1,
    IT: 1,
    JO: 6,
    KG: 1,
    KW: 6,
    KZ: 1,
    LB: 1,
    LI: 1,
    LK: 1,
    LT: 1,
    LU: 1,
    LV: 1,
    LY: 6,
    MC: 1,
    MD: 1,
    ME: 1,
    MK: 1,
    MN: 1,
    MQ: 1,
    MV: 5,
    MY: 1,
    NL: 1,
    NO: 1,
    NZ: 1,
    OM: 6,
    PL: 1,
    QA: 6,
    RE: 1,
    RO: 1,
    RS: 1,
    RU: 1,
    SD: 6,
    SE: 1,
    SI: 1,
    SK: 1,
    SM: 1,
    SY: 6,
    TJ: 1,
    TM: 1,
    TR: 1,
    UA: 1,
    UY: 1,
    UZ: 1,
    VA: 1,
    VN: 1,
    XK: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"dsXT6":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Parses an ISO 8601 time string. */ parcelHelpers.export(exports, "parseTime", function() {
    return parseTime;
});
/** Parses an ISO 8601 date string, with no time components. */ parcelHelpers.export(exports, "parseDate", function() {
    return parseDate;
});
/** Parses an ISO 8601 date and time string, with no time zone. */ parcelHelpers.export(exports, "parseDateTime", function() {
    return parseDateTime;
});
/**
 * Parses an ISO 8601 date and time string with a time zone extension and optional UTC offset
 * (e.g. "2021-11-07T00:45[America/Los_Angeles]" or "2021-11-07T00:45-07:00[America/Los_Angeles]").
 * Ambiguous times due to daylight saving time transitions are resolved according to the `disambiguation`
 * parameter.
 */ parcelHelpers.export(exports, "parseZonedDateTime", function() {
    return parseZonedDateTime;
});
/**
 * Parses an ISO 8601 date and time string with a UTC offset (e.g. "2021-11-07T07:45:00Z"
 * or "2021-11-07T07:45:00-07:00"). The result is converted to the provided time zone.
 */ parcelHelpers.export(exports, "parseAbsolute", function() {
    return parseAbsolute;
});
/**
 * Parses an ISO 8601 date and time string with a UTC offset (e.g. "2021-11-07T07:45:00Z"
 * or "2021-11-07T07:45:00-07:00"). The result is converted to the user's local time zone.
 */ parcelHelpers.export(exports, "parseAbsoluteToLocal", function() {
    return parseAbsoluteToLocal;
});
parcelHelpers.export(exports, "timeToString", function() {
    return timeToString;
});
parcelHelpers.export(exports, "dateToString", function() {
    return dateToString;
});
parcelHelpers.export(exports, "dateTimeToString", function() {
    return dateTimeToString;
});
parcelHelpers.export(exports, "zonedDateTimeToString", function() {
    return zonedDateTimeToString;
});
/**
 * Parses an ISO 8601 duration string (e.g. "P3Y6M6W4DT12H30M5S").
 * @param value An ISO 8601 duration string.
 * @returns A DateTimeDuration object.
 */ parcelHelpers.export(exports, "parseDuration", function() {
    return parseDuration;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _calendarDate = require("./CalendarDate");
var _conversion = require("./conversion");
var _queries = require("./queries");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
var TIME_RE = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
var DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
var DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
var ZONED_DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::?(\d{2}))?)?\[(.*?)\]$/;
var ABSOLUTE_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
var DATE_TIME_DURATION_RE = RegExp("^((?<negative>-)|\\+)?P((?<years>\\d*)Y)?((?<months>\\d*)M)?((?<weeks>\\d*)W)?((?<days>\\d*)D)?((?<time>T)((?<hours>\\d*[.,]?\\d{1,9})H)?((?<minutes>\\d*[.,]?\\d{1,9})M)?((?<seconds>\\d*[.,]?\\d{1,9})S)?)?$");
var requiredDurationTimeGroups = [
    "hours",
    "minutes",
    "seconds"
];
var requiredDurationGroups = [
    "years",
    "months",
    "weeks",
    "days"
].concat((0, _toConsumableArray._)(requiredDurationTimeGroups));
function parseTime(value) {
    var m = value.match(TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 time string: " + value);
    return new (0, _calendarDate.Time)(parseNumber(m[1], 0, 23), m[2] ? parseNumber(m[2], 0, 59) : 0, m[3] ? parseNumber(m[3], 0, 59) : 0, m[4] ? parseNumber(m[4], 0, Infinity) * 1000 : 0);
}
function parseDate(value) {
    var m = value.match(DATE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date string: " + value);
    var date = new (0, _calendarDate.CalendarDate)(parseNumber(m[1], 0, 9999), parseNumber(m[2], 1, 12), 1);
    date.day = parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function parseDateTime(value) {
    var m = value.match(DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    var date = new (0, _calendarDate.CalendarDateTime)(parseNumber(m[1], 1, 9999), parseNumber(m[2], 1, 12), 1, m[4] ? parseNumber(m[4], 0, 23) : 0, m[5] ? parseNumber(m[5], 0, 59) : 0, m[6] ? parseNumber(m[6], 0, 59) : 0, m[7] ? parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function parseZonedDateTime(value, disambiguation) {
    var m = value.match(ZONED_DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    var date = new (0, _calendarDate.ZonedDateTime)(parseNumber(m[1], 1, 9999), parseNumber(m[2], 1, 12), 1, m[10], 0, m[4] ? parseNumber(m[4], 0, 23) : 0, m[5] ? parseNumber(m[5], 0, 59) : 0, m[6] ? parseNumber(m[6], 0, 59) : 0, m[7] ? parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var plainDateTime = (0, _conversion.toCalendarDateTime)(date);
    var ms;
    if (m[8]) {
        var _m_;
        date.offset = parseNumber(m[8], -23, 23) * 3600000 + parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : "0", 0, 59) * 60000;
        ms = (0, _conversion.epochFromDate)(date) - date.offset;
        // Validate offset against parsed date.
        var absolutes = (0, _conversion.possibleAbsolutes)(plainDateTime, date.timeZone);
        if (!absolutes.includes(ms)) throw new Error("Offset ".concat(offsetToString(date.offset), " is invalid for ").concat(dateTimeToString(date), " in ").concat(date.timeZone));
    } else // Convert to absolute and back to fix invalid times due to DST.
    ms = (0, _conversion.toAbsolute)((0, _conversion.toCalendarDateTime)(plainDateTime), date.timeZone, disambiguation);
    return (0, _conversion.fromAbsolute)(ms, date.timeZone);
}
function parseAbsolute(value, timeZone) {
    var m = value.match(ABSOLUTE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    var date = new (0, _calendarDate.ZonedDateTime)(parseNumber(m[1], 1, 9999), parseNumber(m[2], 1, 12), 1, timeZone, 0, m[4] ? parseNumber(m[4], 0, 23) : 0, m[5] ? parseNumber(m[5], 0, 59) : 0, m[6] ? parseNumber(m[6], 0, 59) : 0, m[7] ? parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var _m_;
    if (m[8]) date.offset = parseNumber(m[8], -23, 23) * 3600000 + parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : "0", 0, 59) * 60000;
    return (0, _conversion.toTimeZone)(date, timeZone);
}
function parseAbsoluteToLocal(value) {
    return parseAbsolute(value, (0, _queries.getLocalTimeZone)());
}
function parseNumber(value, min, max) {
    var val = Number(value);
    if (val < min || val > max) throw new RangeError("Value out of range: ".concat(min, " <= ").concat(val, " <= ").concat(max));
    return val;
}
function timeToString(time) {
    return "".concat(String(time.hour).padStart(2, "0"), ":").concat(String(time.minute).padStart(2, "0"), ":").concat(String(time.second).padStart(2, "0")).concat(time.millisecond ? String(time.millisecond / 1000).slice(1) : "");
}
function dateToString(date) {
    var gregorianDate = (0, _conversion.toCalendar)(date, new (0, _gregorianCalendar.GregorianCalendar)());
    return "".concat(String(gregorianDate.year).padStart(4, "0"), "-").concat(String(gregorianDate.month).padStart(2, "0"), "-").concat(String(gregorianDate.day).padStart(2, "0"));
}
function dateTimeToString(date) {
    // @ts-ignore
    return "".concat(dateToString(date), "T").concat(timeToString(date));
}
function offsetToString(offset) {
    var sign = Math.sign(offset) < 0 ? "-" : "+";
    offset = Math.abs(offset);
    var offsetHours = Math.floor(offset / 3600000);
    var offsetMinutes = offset % 3600000 / 60000;
    return "".concat(sign).concat(String(offsetHours).padStart(2, "0"), ":").concat(String(offsetMinutes).padStart(2, "0"));
}
function zonedDateTimeToString(date) {
    return "".concat(dateTimeToString(date)).concat(offsetToString(date.offset), "[").concat(date.timeZone, "]");
}
function parseDuration(value) {
    var _match_groups, _match_groups1, _match_groups2, _match_groups3, _match_groups4, _match_groups5, _match_groups6, _match_groups7, _match_groups8;
    var match = value.match(DATE_TIME_DURATION_RE);
    if (!match) throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
    var parseDurationGroup = function(group, isNegative, min, max) {
        if (!group) return 0;
        try {
            var sign = isNegative ? -1 : 1;
            return sign * parseNumber(group.replace(",", "."), min, max);
        } catch (e) {
            throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
        }
    };
    var isNegative = !!((_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups.negative);
    var hasRequiredGroups = requiredDurationGroups.some(function(group) {
        var _match_groups;
        return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
    });
    if (!hasRequiredGroups) throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
    var durationStringIncludesTime = (_match_groups1 = match.groups) === null || _match_groups1 === void 0 ? void 0 : _match_groups1.time;
    if (durationStringIncludesTime) {
        var hasRequiredDurationTimeGroups = requiredDurationTimeGroups.some(function(group) {
            var _match_groups;
            return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
        });
        if (!hasRequiredDurationTimeGroups) throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
    }
    var duration = {
        years: parseDurationGroup((_match_groups2 = match.groups) === null || _match_groups2 === void 0 ? void 0 : _match_groups2.years, isNegative, 0, 9999),
        months: parseDurationGroup((_match_groups3 = match.groups) === null || _match_groups3 === void 0 ? void 0 : _match_groups3.months, isNegative, 0, 12),
        weeks: parseDurationGroup((_match_groups4 = match.groups) === null || _match_groups4 === void 0 ? void 0 : _match_groups4.weeks, isNegative, 0, Infinity),
        days: parseDurationGroup((_match_groups5 = match.groups) === null || _match_groups5 === void 0 ? void 0 : _match_groups5.days, isNegative, 0, 31),
        hours: parseDurationGroup((_match_groups6 = match.groups) === null || _match_groups6 === void 0 ? void 0 : _match_groups6.hours, isNegative, 0, 23),
        minutes: parseDurationGroup((_match_groups7 = match.groups) === null || _match_groups7 === void 0 ? void 0 : _match_groups7.minutes, isNegative, 0, 59),
        seconds: parseDurationGroup((_match_groups8 = match.groups) === null || _match_groups8 === void 0 ? void 0 : _match_groups8.seconds, isNegative, 0, 59)
    };
    if (duration.hours !== undefined && duration.hours % 1 !== 0 && (duration.minutes || duration.seconds)) throw new Error("Invalid ISO 8601 Duration string: ".concat(value, " - only the smallest unit can be fractional"));
    if (duration.minutes !== undefined && duration.minutes % 1 !== 0 && duration.seconds) throw new Error("Invalid ISO 8601 Duration string: ".concat(value, " - only the smallest unit can be fractional"));
    return duration;
}

},{"@swc/helpers/_/_to_consumable_array":"4Hwej","./CalendarDate":"bo84l","./conversion":"aECo1","./queries":"3jJiZ","./calendars/GregorianCalendar":"CFsNw","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"9mSVu":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JapaneseCalendar", function() {
    return JapaneseCalendar;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _createSuper = require("@swc/helpers/_/_create_super");
var _calendarDate = require("../CalendarDate");
var _gregorianCalendar = require("./GregorianCalendar");
var ERA_START_DATES = [
    [
        1868,
        9,
        8
    ],
    [
        1912,
        7,
        30
    ],
    [
        1926,
        12,
        25
    ],
    [
        1989,
        1,
        8
    ],
    [
        2019,
        5,
        1
    ]
];
var ERA_END_DATES = [
    [
        1912,
        7,
        29
    ],
    [
        1926,
        12,
        24
    ],
    [
        1989,
        1,
        7
    ],
    [
        2019,
        4,
        30
    ]
];
var ERA_ADDENDS = [
    1867,
    1911,
    1925,
    1988,
    2018
];
var ERA_NAMES = [
    "meiji",
    "taisho",
    "showa",
    "heisei",
    "reiwa"
];
function findEraFromGregorianDate(date) {
    var idx = ERA_START_DATES.findIndex(function(param) {
        var _param = (0, _slicedToArray._)(param, 3), year = _param[0], month = _param[1], day = _param[2];
        if (date.year < year) return true;
        if (date.year === year && date.month < month) return true;
        if (date.year === year && date.month === month && date.day < day) return true;
        return false;
    });
    if (idx === -1) return ERA_START_DATES.length - 1;
    if (idx === 0) return 0;
    return idx - 1;
}
function toGregorian(date) {
    var eraAddend = ERA_ADDENDS[ERA_NAMES.indexOf(date.era)];
    if (!eraAddend) throw new Error("Unknown era: " + date.era);
    return new (0, _calendarDate.CalendarDate)(date.year + eraAddend, date.month, date.day);
}
var JapaneseCalendar = /*#__PURE__*/ function(GregorianCalendar) {
    "use strict";
    (0, _inherits._)(JapaneseCalendar, GregorianCalendar);
    var _super = (0, _createSuper._)(JapaneseCalendar);
    function JapaneseCalendar() {
        (0, _classCallCheck._)(this, JapaneseCalendar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.identifier = "japanese";
        return _this;
    }
    (0, _createClass._)(JapaneseCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var date = (0, _get._)((0, _getPrototypeOf._)(JapaneseCalendar.prototype), "fromJulianDay", this).call(this, jd);
                var era = findEraFromGregorianDate(date);
                return new (0, _calendarDate.CalendarDate)(this, ERA_NAMES[era], date.year - ERA_ADDENDS[era], date.month, date.day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return (0, _get._)((0, _getPrototypeOf._)(JapaneseCalendar.prototype), "toJulianDay", this).call(this, toGregorian(date));
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                var gregorianDate = toGregorian(date);
                var era = findEraFromGregorianDate(gregorianDate);
                if (ERA_NAMES[era] !== date.era) {
                    date.era = ERA_NAMES[era];
                    date.year = gregorianDate.year - ERA_ADDENDS[era];
                }
                // Constrain in case we went before the first supported era.
                this.constrainDate(date);
            }
        },
        {
            key: "constrainDate",
            value: function constrainDate(date) {
                var idx = ERA_NAMES.indexOf(date.era);
                var end = ERA_END_DATES[idx];
                if (end != null) {
                    var _end = (0, _slicedToArray._)(end, 3), endYear = _end[0], endMonth = _end[1], endDay = _end[2];
                    // Constrain the year to the maximum possible value in the era.
                    // Then constrain the month and day fields within that.
                    var maxYear = endYear - ERA_ADDENDS[idx];
                    date.year = Math.max(1, Math.min(maxYear, date.year));
                    if (date.year === maxYear) {
                        date.month = Math.min(endMonth, date.month);
                        if (date.month === endMonth) date.day = Math.min(endDay, date.day);
                    }
                }
                if (date.year === 1 && idx >= 0) {
                    var _ERA_START_DATES_idx = (0, _slicedToArray._)(ERA_START_DATES[idx], 3), startMonth = _ERA_START_DATES_idx[1], startDay = _ERA_START_DATES_idx[2];
                    date.month = Math.max(startMonth, date.month);
                    if (date.month === startMonth) date.day = Math.max(startDay, date.day);
                }
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return ERA_NAMES;
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                // Get the number of years in the era, taking into account the date's month and day fields.
                var era = ERA_NAMES.indexOf(date.era);
                var cur = ERA_START_DATES[era];
                var next = ERA_START_DATES[era + 1];
                if (next == null) // 9999 gregorian is the maximum year allowed.
                return 9999 - cur[0] + 1;
                var years = next[0] - cur[0];
                if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
                return years;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return (0, _get._)((0, _getPrototypeOf._)(JapaneseCalendar.prototype), "getDaysInMonth", this).call(this, toGregorian(date));
            }
        },
        {
            key: "getMinimumMonthInYear",
            value: function getMinimumMonthInYear(date) {
                var start = getMinimums(date);
                return start ? start[1] : 1;
            }
        },
        {
            key: "getMinimumDayInMonth",
            value: function getMinimumDayInMonth(date) {
                var start = getMinimums(date);
                return start && date.month === start[1] ? start[2] : 1;
            }
        }
    ]);
    return JapaneseCalendar;
}((0, _gregorianCalendar.GregorianCalendar));
function getMinimums(date) {
    if (date.year === 1) {
        var idx = ERA_NAMES.indexOf(date.era);
        return ERA_START_DATES[idx];
    }
}

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_get":"4p6cE","@swc/helpers/_/_get_prototype_of":"3bBK0","@swc/helpers/_/_inherits":"aYVfo","@swc/helpers/_/_sliced_to_array":"jzEiA","@swc/helpers/_/_create_super":"31igY","../CalendarDate":"bo84l","./GregorianCalendar":"CFsNw","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"asUIt":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuddhistCalendar", function() {
    return BuddhistCalendar;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _createSuper = require("@swc/helpers/_/_create_super");
var _calendarDate = require("../CalendarDate");
var _gregorianCalendar = require("./GregorianCalendar");
var BUDDHIST_ERA_START = -543;
var BuddhistCalendar = /*#__PURE__*/ function(GregorianCalendar) {
    "use strict";
    (0, _inherits._)(BuddhistCalendar, GregorianCalendar);
    var _super = (0, _createSuper._)(BuddhistCalendar);
    function BuddhistCalendar() {
        (0, _classCallCheck._)(this, BuddhistCalendar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.identifier = "buddhist";
        return _this;
    }
    (0, _createClass._)(BuddhistCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var gregorianDate = (0, _get._)((0, _getPrototypeOf._)(BuddhistCalendar.prototype), "fromJulianDay", this).call(this, jd);
                var year = (0, _gregorianCalendar.getExtendedYear)(gregorianDate.era, gregorianDate.year);
                return new (0, _calendarDate.CalendarDate)(this, year - BUDDHIST_ERA_START, gregorianDate.month, gregorianDate.day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return (0, _get._)((0, _getPrototypeOf._)(BuddhistCalendar.prototype), "toJulianDay", this).call(this, toGregorian(date));
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "BE"
                ];
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return (0, _get._)((0, _getPrototypeOf._)(BuddhistCalendar.prototype), "getDaysInMonth", this).call(this, toGregorian(date));
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate() {}
        }
    ]);
    return BuddhistCalendar;
}((0, _gregorianCalendar.GregorianCalendar));
function toGregorian(date) {
    var _fromExtendedYear = (0, _slicedToArray._)((0, _gregorianCalendar.fromExtendedYear)(date.year + BUDDHIST_ERA_START), 2), era = _fromExtendedYear[0], year = _fromExtendedYear[1];
    return new (0, _calendarDate.CalendarDate)(era, year, date.month, date.day);
}

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_get":"4p6cE","@swc/helpers/_/_get_prototype_of":"3bBK0","@swc/helpers/_/_inherits":"aYVfo","@swc/helpers/_/_sliced_to_array":"jzEiA","@swc/helpers/_/_create_super":"31igY","../CalendarDate":"bo84l","./GregorianCalendar":"CFsNw","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"bT8Ng":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TaiwanCalendar", function() {
    return TaiwanCalendar;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _createSuper = require("@swc/helpers/_/_create_super");
var _calendarDate = require("../CalendarDate");
var _gregorianCalendar = require("./GregorianCalendar");
var TAIWAN_ERA_START = 1911;
function gregorianYear(date) {
    return date.era === "minguo" ? date.year + TAIWAN_ERA_START : 1 - date.year + TAIWAN_ERA_START;
}
function gregorianToTaiwan(year) {
    var y = year - TAIWAN_ERA_START;
    if (y > 0) return [
        "minguo",
        y
    ];
    else return [
        "before_minguo",
        1 - y
    ];
}
var TaiwanCalendar = /*#__PURE__*/ function(GregorianCalendar) {
    "use strict";
    (0, _inherits._)(TaiwanCalendar, GregorianCalendar);
    var _super = (0, _createSuper._)(TaiwanCalendar);
    function TaiwanCalendar() {
        (0, _classCallCheck._)(this, TaiwanCalendar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.identifier = "roc" // Republic of China
        ;
        return _this;
    }
    (0, _createClass._)(TaiwanCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var date = (0, _get._)((0, _getPrototypeOf._)(TaiwanCalendar.prototype), "fromJulianDay", this).call(this, jd);
                var extendedYear = (0, _gregorianCalendar.getExtendedYear)(date.era, date.year);
                var _gregorianToTaiwan = (0, _slicedToArray._)(gregorianToTaiwan(extendedYear), 2), era = _gregorianToTaiwan[0], year = _gregorianToTaiwan[1];
                return new (0, _calendarDate.CalendarDate)(this, era, year, date.month, date.day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return (0, _get._)((0, _getPrototypeOf._)(TaiwanCalendar.prototype), "toJulianDay", this).call(this, toGregorian(date));
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "before_minguo",
                    "minguo"
                ];
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                var _gregorianToTaiwan = (0, _slicedToArray._)(gregorianToTaiwan(gregorianYear(date)), 2), era = _gregorianToTaiwan[0], year = _gregorianToTaiwan[1];
                date.era = era;
                date.year = year;
            }
        },
        {
            key: "isInverseEra",
            value: function isInverseEra(date) {
                return date.era === "before_minguo";
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return (0, _get._)((0, _getPrototypeOf._)(TaiwanCalendar.prototype), "getDaysInMonth", this).call(this, toGregorian(date));
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                return date.era === "before_minguo" ? 9999 : 9999 - TAIWAN_ERA_START;
            }
        }
    ]);
    return TaiwanCalendar;
}((0, _gregorianCalendar.GregorianCalendar));
function toGregorian(date) {
    var _fromExtendedYear = (0, _slicedToArray._)((0, _gregorianCalendar.fromExtendedYear)(gregorianYear(date)), 2), era = _fromExtendedYear[0], year = _fromExtendedYear[1];
    return new (0, _calendarDate.CalendarDate)(era, year, date.month, date.day);
}

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_get":"4p6cE","@swc/helpers/_/_get_prototype_of":"3bBK0","@swc/helpers/_/_inherits":"aYVfo","@swc/helpers/_/_sliced_to_array":"jzEiA","@swc/helpers/_/_create_super":"31igY","../CalendarDate":"bo84l","./GregorianCalendar":"CFsNw","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"a4zzG":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PersianCalendar", function() {
    return PersianCalendar;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _calendarDate = require("../CalendarDate");
var _utils = require("../utils");
var PERSIAN_EPOCH = 1948320;
// Number of days from the start of the year to the start of each month.
var MONTH_START = [
    0,
    31,
    62,
    93,
    124,
    155,
    186,
    216,
    246,
    276,
    306,
    336 // Esfand
];
var PersianCalendar = /*#__PURE__*/ function() {
    "use strict";
    function PersianCalendar() {
        (0, _classCallCheck._)(this, PersianCalendar);
        this.identifier = "persian";
    }
    (0, _createClass._)(PersianCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var daysSinceEpoch = jd - PERSIAN_EPOCH;
                var year = 1 + Math.floor((33 * daysSinceEpoch + 3) / 12053);
                var farvardin1 = 365 * (year - 1) + Math.floor((8 * year + 21) / 33);
                var dayOfYear = daysSinceEpoch - farvardin1;
                var month = dayOfYear < 216 ? Math.floor(dayOfYear / 31) : Math.floor((dayOfYear - 6) / 30);
                var day = dayOfYear - MONTH_START[month] + 1;
                return new (0, _calendarDate.CalendarDate)(this, year, month + 1, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var jd = PERSIAN_EPOCH - 1 + 365 * (date.year - 1) + Math.floor((8 * date.year + 21) / 33);
                jd += MONTH_START[date.month - 1];
                jd += date.day;
                return jd;
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear() {
                return 12;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                if (date.month <= 6) return 31;
                if (date.month <= 11) return 30;
                var isLeapYear = (0, _utils.mod)(25 * date.year + 11, 33) < 8;
                return isLeapYear ? 30 : 29;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "AP"
                ];
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9378-10-10 persian is 9999-12-31 gregorian.
                // Round down to 9377 to set the maximum full year.
                return 9377;
            }
        }
    ]);
    return PersianCalendar;
}();

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","../CalendarDate":"bo84l","../utils":"8Jhao","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"8ghe3":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IndianCalendar", function() {
    return IndianCalendar;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _createSuper = require("@swc/helpers/_/_create_super");
var _calendarDate = require("../CalendarDate");
var _gregorianCalendar = require("./GregorianCalendar");
// Starts in 78 AD,
var INDIAN_ERA_START = 78;
// The Indian year starts 80 days later than the Gregorian year.
var INDIAN_YEAR_START = 80;
var IndianCalendar = /*#__PURE__*/ function(GregorianCalendar) {
    "use strict";
    (0, _inherits._)(IndianCalendar, GregorianCalendar);
    var _super = (0, _createSuper._)(IndianCalendar);
    function IndianCalendar() {
        (0, _classCallCheck._)(this, IndianCalendar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.identifier = "indian";
        return _this;
    }
    (0, _createClass._)(IndianCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                // Gregorian date for Julian day
                var date = (0, _get._)((0, _getPrototypeOf._)(IndianCalendar.prototype), "fromJulianDay", this).call(this, jd);
                // Year in Saka era
                var indianYear = date.year - INDIAN_ERA_START;
                // Day number in Gregorian year (starting from 0)
                var yDay = jd - (0, _gregorianCalendar.gregorianToJulianDay)(date.era, date.year, 1, 1);
                var leapMonth;
                if (yDay < INDIAN_YEAR_START) {
                    //  Day is at the end of the preceding Saka year
                    indianYear--;
                    // Days in leapMonth this year, previous Gregorian year
                    leapMonth = (0, _gregorianCalendar.isLeapYear)(date.year - 1) ? 31 : 30;
                    yDay += leapMonth + 155 + 90 + 10;
                } else {
                    // Days in leapMonth this year
                    leapMonth = (0, _gregorianCalendar.isLeapYear)(date.year) ? 31 : 30;
                    yDay -= INDIAN_YEAR_START;
                }
                var indianMonth;
                var indianDay;
                if (yDay < leapMonth) {
                    indianMonth = 1;
                    indianDay = yDay + 1;
                } else {
                    var mDay = yDay - leapMonth;
                    if (mDay < 155) {
                        indianMonth = Math.floor(mDay / 31) + 2;
                        indianDay = mDay % 31 + 1;
                    } else {
                        mDay -= 155;
                        indianMonth = Math.floor(mDay / 30) + 7;
                        indianDay = mDay % 30 + 1;
                    }
                }
                return new (0, _calendarDate.CalendarDate)(this, indianYear, indianMonth, indianDay);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var extendedYear = date.year + INDIAN_ERA_START;
                var _fromExtendedYear = (0, _slicedToArray._)((0, _gregorianCalendar.fromExtendedYear)(extendedYear), 2), era = _fromExtendedYear[0], year = _fromExtendedYear[1];
                var leapMonth;
                var jd;
                if ((0, _gregorianCalendar.isLeapYear)(year)) {
                    leapMonth = 31;
                    jd = (0, _gregorianCalendar.gregorianToJulianDay)(era, year, 3, 21);
                } else {
                    leapMonth = 30;
                    jd = (0, _gregorianCalendar.gregorianToJulianDay)(era, year, 3, 22);
                }
                if (date.month === 1) return jd + date.day - 1;
                jd += leapMonth + Math.min(date.month - 2, 5) * 31;
                if (date.month >= 8) jd += (date.month - 7) * 30;
                jd += date.day - 1;
                return jd;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                if (date.month === 1 && (0, _gregorianCalendar.isLeapYear)(date.year + INDIAN_ERA_START)) return 31;
                if (date.month >= 2 && date.month <= 6) return 31;
                return 30;
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9999-12-31 gregorian is 9920-10-10 indian.
                // Round down to 9919 for the last full year.
                return 9919;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "saka"
                ];
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate() {}
        }
    ]);
    return IndianCalendar;
}((0, _gregorianCalendar.GregorianCalendar));

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_get":"4p6cE","@swc/helpers/_/_get_prototype_of":"3bBK0","@swc/helpers/_/_inherits":"aYVfo","@swc/helpers/_/_sliced_to_array":"jzEiA","@swc/helpers/_/_create_super":"31igY","../CalendarDate":"bo84l","./GregorianCalendar":"CFsNw","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"efTuE":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IslamicCivilCalendar", function() {
    return IslamicCivilCalendar;
});
parcelHelpers.export(exports, "IslamicTabularCalendar", function() {
    return IslamicTabularCalendar;
});
parcelHelpers.export(exports, "IslamicUmalquraCalendar", function() {
    return IslamicUmalquraCalendar;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _calendarDate = require("../CalendarDate");
var CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)
var ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)
var UMALQURA_YEAR_START = 1300;
var UMALQURA_YEAR_END = 1600;
var UMALQURA_START_DAYS = 460322;
function islamicToJulianDay(epoch, year, month, day) {
    return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}
function julianDayToIslamic(calendar, epoch, jd) {
    var year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
    var month = Math.min(12, Math.ceil((jd - (29 + islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
    var day = jd - islamicToJulianDay(epoch, year, month, 1) + 1;
    return new (0, _calendarDate.CalendarDate)(calendar, year, month, day);
}
function isLeapYear(year) {
    return (14 + 11 * year) % 30 < 11;
}
var IslamicCivilCalendar = /*#__PURE__*/ function() {
    "use strict";
    function IslamicCivilCalendar() {
        (0, _classCallCheck._)(this, IslamicCivilCalendar);
        this.identifier = "islamic-civil";
    }
    (0, _createClass._)(IslamicCivilCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                return julianDayToIslamic(this, CIVIL_EPOC, jd);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return islamicToJulianDay(CIVIL_EPOC, date.year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                var length = 29 + date.month % 2;
                if (date.month === 12 && isLeapYear(date.year)) length++;
                return length;
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear() {
                return 12;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return isLeapYear(date.year) ? 355 : 354;
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9999 gregorian
                return 9665;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "AH"
                ];
            }
        }
    ]);
    return IslamicCivilCalendar;
}();
var IslamicTabularCalendar = /*#__PURE__*/ function(IslamicCivilCalendar) {
    "use strict";
    (0, _inherits._)(IslamicTabularCalendar, IslamicCivilCalendar);
    var _super = (0, _createSuper._)(IslamicTabularCalendar);
    function IslamicTabularCalendar() {
        (0, _classCallCheck._)(this, IslamicTabularCalendar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.identifier = "islamic-tbla";
        return _this;
    }
    (0, _createClass._)(IslamicTabularCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                return julianDayToIslamic(this, ASTRONOMICAL_EPOC, jd);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return islamicToJulianDay(ASTRONOMICAL_EPOC, date.year, date.month, date.day);
            }
        }
    ]);
    return IslamicTabularCalendar;
}(IslamicCivilCalendar);
// Generated by scripts/generate-umalqura.js
var UMALQURA_DATA = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
var UMALQURA_MONTHLENGTH;
var UMALQURA_YEAR_START_TABLE;
function umalquraYearStart(year) {
    return UMALQURA_START_DAYS + UMALQURA_YEAR_START_TABLE[year - UMALQURA_YEAR_START];
}
function umalquraMonthLength(year, month) {
    var idx = year - UMALQURA_YEAR_START;
    var mask = 0x01 << 11 - (month - 1);
    if ((UMALQURA_MONTHLENGTH[idx] & mask) === 0) return 29;
    else return 30;
}
function umalquraMonthStart(year, month) {
    var day = umalquraYearStart(year);
    for(var i = 1; i < month; i++)day += umalquraMonthLength(year, i);
    return day;
}
function umalquraYearLength(year) {
    return UMALQURA_YEAR_START_TABLE[year + 1 - UMALQURA_YEAR_START] - UMALQURA_YEAR_START_TABLE[year - UMALQURA_YEAR_START];
}
var IslamicUmalquraCalendar = /*#__PURE__*/ function(IslamicCivilCalendar) {
    "use strict";
    (0, _inherits._)(IslamicUmalquraCalendar, IslamicCivilCalendar);
    var _super = (0, _createSuper._)(IslamicUmalquraCalendar);
    function IslamicUmalquraCalendar() {
        (0, _classCallCheck._)(this, IslamicUmalquraCalendar);
        var _this;
        _this = _super.call(this);
        _this.identifier = "islamic-umalqura";
        if (!UMALQURA_MONTHLENGTH) UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob(UMALQURA_DATA), function(c) {
            return c.charCodeAt(0);
        }).buffer);
        if (!UMALQURA_YEAR_START_TABLE) {
            UMALQURA_YEAR_START_TABLE = new Uint32Array(UMALQURA_YEAR_END - UMALQURA_YEAR_START + 1);
            var yearStart = 0;
            for(var year = UMALQURA_YEAR_START; year <= UMALQURA_YEAR_END; year++){
                UMALQURA_YEAR_START_TABLE[year - UMALQURA_YEAR_START] = yearStart;
                for(var i = 1; i <= 12; i++)yearStart += umalquraMonthLength(year, i);
            }
        }
        return _this;
    }
    (0, _createClass._)(IslamicUmalquraCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var days = jd - CIVIL_EPOC;
                var startDays = umalquraYearStart(UMALQURA_YEAR_START);
                var endDays = umalquraYearStart(UMALQURA_YEAR_END);
                if (days < startDays || days > endDays) return (0, _get._)((0, _getPrototypeOf._)(IslamicUmalquraCalendar.prototype), "fromJulianDay", this).call(this, jd);
                else {
                    var y = UMALQURA_YEAR_START - 1;
                    var m = 1;
                    var d = 1;
                    while(d > 0){
                        y++;
                        d = days - umalquraYearStart(y) + 1;
                        var yearLength = umalquraYearLength(y);
                        if (d === yearLength) {
                            m = 12;
                            break;
                        } else if (d < yearLength) {
                            var monthLength = umalquraMonthLength(y, m);
                            m = 1;
                            while(d > monthLength){
                                d -= monthLength;
                                m++;
                                monthLength = umalquraMonthLength(y, m);
                            }
                            break;
                        }
                    }
                    return new (0, _calendarDate.CalendarDate)(this, y, m, days - umalquraMonthStart(y, m) + 1);
                }
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                if (date.year < UMALQURA_YEAR_START || date.year > UMALQURA_YEAR_END) return (0, _get._)((0, _getPrototypeOf._)(IslamicUmalquraCalendar.prototype), "toJulianDay", this).call(this, date);
                return CIVIL_EPOC + umalquraMonthStart(date.year, date.month) + (date.day - 1);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                if (date.year < UMALQURA_YEAR_START || date.year > UMALQURA_YEAR_END) return (0, _get._)((0, _getPrototypeOf._)(IslamicUmalquraCalendar.prototype), "getDaysInMonth", this).call(this, date);
                return umalquraMonthLength(date.year, date.month);
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                if (date.year < UMALQURA_YEAR_START || date.year > UMALQURA_YEAR_END) return (0, _get._)((0, _getPrototypeOf._)(IslamicUmalquraCalendar.prototype), "getDaysInYear", this).call(this, date);
                return umalquraYearLength(date.year);
            }
        }
    ]);
    return IslamicUmalquraCalendar;
}(IslamicCivilCalendar);

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_get":"4p6cE","@swc/helpers/_/_get_prototype_of":"3bBK0","@swc/helpers/_/_inherits":"aYVfo","@swc/helpers/_/_create_super":"31igY","../CalendarDate":"bo84l","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"7Hw3F":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HebrewCalendar", function() {
    return HebrewCalendar;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _calendarDate = require("../CalendarDate");
var _utils = require("../utils");
var HEBREW_EPOCH = 347997;
// Hebrew date calculations are performed in terms of days, hours, and
// "parts" (or halakim), which are 1/1080 of an hour, or 3 1/3 seconds.
var HOUR_PARTS = 1080;
var DAY_PARTS = 24 * HOUR_PARTS;
// An approximate value for the length of a lunar month.
// It is used to calculate the approximate year and month of a given
// absolute date.
var MONTH_DAYS = 29;
var MONTH_FRACT = 12 * HOUR_PARTS + 793;
var MONTH_PARTS = MONTH_DAYS * DAY_PARTS + MONTH_FRACT;
function isLeapYear(year) {
    return (0, _utils.mod)(year * 7 + 1, 19) < 7;
}
// Test for delay of start of new year and to avoid
// Sunday, Wednesday, and Friday as start of the new year.
function hebrewDelay1(year) {
    var months = Math.floor((235 * year - 234) / 19);
    var parts = 12084 + 13753 * months;
    var day = months * 29 + Math.floor(parts / 25920);
    if ((0, _utils.mod)(3 * (day + 1), 7) < 3) day += 1;
    return day;
}
// Check for delay in start of new year due to length of adjacent years
function hebrewDelay2(year) {
    var last = hebrewDelay1(year - 1);
    var present = hebrewDelay1(year);
    var next = hebrewDelay1(year + 1);
    if (next - present === 356) return 2;
    if (present - last === 382) return 1;
    return 0;
}
function startOfYear(year) {
    return hebrewDelay1(year) + hebrewDelay2(year);
}
function getDaysInYear(year) {
    return startOfYear(year + 1) - startOfYear(year);
}
function getYearType(year) {
    var yearLength = getDaysInYear(year);
    if (yearLength > 380) yearLength -= 30; // Subtract length of leap month.
    switch(yearLength){
        case 353:
            return 0; // deficient
        case 354:
            return 1; // normal
        case 355:
            return 2; // complete
    }
}
function getDaysInMonth(year, month) {
    // Normalize month numbers from 1 - 13, even on non-leap years
    if (month >= 6 && !isLeapYear(year)) month++;
    // First of all, dispose of fixed-length 29 day months
    if (month === 4 || month === 7 || month === 9 || month === 11 || month === 13) return 29;
    var yearType = getYearType(year);
    // If it's Heshvan, days depend on length of year
    if (month === 2) return yearType === 2 ? 30 : 29;
    // Similarly, Kislev varies with the length of year
    if (month === 3) return yearType === 0 ? 29 : 30;
    // Adar I only exists in leap years
    if (month === 6) return isLeapYear(year) ? 30 : 0;
    return 30;
}
var HebrewCalendar = /*#__PURE__*/ function() {
    "use strict";
    function HebrewCalendar() {
        (0, _classCallCheck._)(this, HebrewCalendar);
        this.identifier = "hebrew";
    }
    (0, _createClass._)(HebrewCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var d = jd - HEBREW_EPOCH;
                var m = d * DAY_PARTS / MONTH_PARTS; // Months (approx)
                var year = Math.floor((19 * m + 234) / 235) + 1; // Years (approx)
                var ys = startOfYear(year); // 1st day of year
                var dayOfYear = Math.floor(d - ys);
                // Because of the postponement rules, it's possible to guess wrong.  Fix it.
                while(dayOfYear < 1){
                    year--;
                    ys = startOfYear(year);
                    dayOfYear = Math.floor(d - ys);
                }
                // Now figure out which month we're in, and the date within that month
                var month = 1;
                var monthStart = 0;
                while(monthStart < dayOfYear){
                    monthStart += getDaysInMonth(year, month);
                    month++;
                }
                month--;
                monthStart -= getDaysInMonth(year, month);
                var day = dayOfYear - monthStart;
                return new (0, _calendarDate.CalendarDate)(this, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var jd = startOfYear(date.year);
                for(var month = 1; month < date.month; month++)jd += getDaysInMonth(date.year, month);
                return jd + date.day + HEBREW_EPOCH;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth1(date) {
                return getDaysInMonth(date.year, date.month);
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear(date) {
                return isLeapYear(date.year) ? 13 : 12;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear1(date) {
                return getDaysInYear(date.year);
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 6239 gregorian
                return 9999;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "AM"
                ];
            }
        },
        {
            key: "balanceYearMonth",
            value: function balanceYearMonth(date, previousDate) {
                // Keep date in the same month when switching between leap years and non leap years
                if (previousDate.year !== date.year) {
                    if (isLeapYear(previousDate.year) && !isLeapYear(date.year) && previousDate.month > 6) date.month--;
                    else if (!isLeapYear(previousDate.year) && isLeapYear(date.year) && previousDate.month > 6) date.month++;
                }
            }
        }
    ]);
    return HebrewCalendar;
}();

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","../CalendarDate":"bo84l","../utils":"8Jhao","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"b6ija":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EthiopicCalendar", function() {
    return EthiopicCalendar;
});
parcelHelpers.export(exports, "EthiopicAmeteAlemCalendar", function() {
    return EthiopicAmeteAlemCalendar;
});
parcelHelpers.export(exports, "CopticCalendar", function() {
    return CopticCalendar;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _createSuper = require("@swc/helpers/_/_create_super");
var _calendarDate = require("../CalendarDate");
var ETHIOPIC_EPOCH = 1723856;
var COPTIC_EPOCH = 1824665;
// The delta between Amete Alem 1 and Amete Mihret 1
// AA 5501 = AM 1
var AMETE_MIHRET_DELTA = 5500;
function ceToJulianDay(epoch, year, month, day) {
    return epoch // difference from Julian epoch to 1,1,1
     + 365 * year // number of days from years
     + Math.floor(year / 4) // extra day of leap year
     + 30 * (month - 1 // number of days from months (1 based)
    ) + day - 1 // number of days for present month (1 based)
    ;
}
function julianDayToCE(epoch, jd) {
    var year = Math.floor(4 * (jd - epoch) / 1461);
    var month = 1 + Math.floor((jd - ceToJulianDay(epoch, year, 1, 1)) / 30);
    var day = jd + 1 - ceToJulianDay(epoch, year, month, 1);
    return [
        year,
        month,
        day
    ];
}
function getLeapDay(year) {
    return Math.floor(year % 4 / 3);
}
function getDaysInMonth(year, month) {
    // The Ethiopian and Coptic calendars have 13 months, 12 of 30 days each and
    // an intercalary month at the end of the year of 5 or 6 days, depending whether
    // the year is a leap year or not. The Leap Year follows the same rules as the
    // Julian Calendar so that the extra month always has six days in the year before
    // a Julian Leap Year.
    if (month % 13 !== 0) // not intercalary month
    return 30;
    else // intercalary month 5 days + possible leap day
    return getLeapDay(year) + 5;
}
var EthiopicCalendar = /*#__PURE__*/ function() {
    "use strict";
    function EthiopicCalendar() {
        (0, _classCallCheck._)(this, EthiopicCalendar);
        this.identifier = "ethiopic";
    }
    (0, _createClass._)(EthiopicCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var _julianDayToCE = (0, _slicedToArray._)(julianDayToCE(ETHIOPIC_EPOCH, jd), 3), year = _julianDayToCE[0], month = _julianDayToCE[1], day = _julianDayToCE[2];
                var era = "AM";
                if (year <= 0) {
                    era = "AA";
                    year += AMETE_MIHRET_DELTA;
                }
                return new (0, _calendarDate.CalendarDate)(this, era, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var year = date.year;
                if (date.era === "AA") year -= AMETE_MIHRET_DELTA;
                return ceToJulianDay(ETHIOPIC_EPOCH, year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth1(date) {
                return getDaysInMonth(date.year, date.month);
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear() {
                return 13;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return 365 + getLeapDay(date.year);
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                // 9999-12-31 gregorian is 9992-20-02 ethiopic.
                // Round down to 9991 for the last full year.
                // AA 9999-01-01 ethiopic is 4506-09-30 gregorian.
                return date.era === "AA" ? 9999 : 9991;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "AA",
                    "AM"
                ];
            }
        }
    ]);
    return EthiopicCalendar;
}();
var EthiopicAmeteAlemCalendar = /*#__PURE__*/ function(EthiopicCalendar) {
    "use strict";
    (0, _inherits._)(EthiopicAmeteAlemCalendar, EthiopicCalendar);
    var _super = (0, _createSuper._)(EthiopicAmeteAlemCalendar);
    function EthiopicAmeteAlemCalendar() {
        (0, _classCallCheck._)(this, EthiopicAmeteAlemCalendar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.identifier = "ethioaa" // also known as 'ethiopic-amete-alem' in ICU
        ;
        return _this;
    }
    (0, _createClass._)(EthiopicAmeteAlemCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var _julianDayToCE = (0, _slicedToArray._)(julianDayToCE(ETHIOPIC_EPOCH, jd), 3), year = _julianDayToCE[0], month = _julianDayToCE[1], day = _julianDayToCE[2];
                year += AMETE_MIHRET_DELTA;
                return new (0, _calendarDate.CalendarDate)(this, "AA", year, month, day);
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "AA"
                ];
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9999-13-04 ethioaa is the maximum date, which is equivalent to 4506-09-29 gregorian.
                return 9999;
            }
        }
    ]);
    return EthiopicAmeteAlemCalendar;
}(EthiopicCalendar);
var CopticCalendar = /*#__PURE__*/ function(EthiopicCalendar) {
    "use strict";
    (0, _inherits._)(CopticCalendar, EthiopicCalendar);
    var _super = (0, _createSuper._)(CopticCalendar);
    function CopticCalendar() {
        (0, _classCallCheck._)(this, CopticCalendar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.identifier = "coptic";
        return _this;
    }
    (0, _createClass._)(CopticCalendar, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var _julianDayToCE = (0, _slicedToArray._)(julianDayToCE(COPTIC_EPOCH, jd), 3), year = _julianDayToCE[0], month = _julianDayToCE[1], day = _julianDayToCE[2];
                var era = "CE";
                if (year <= 0) {
                    era = "BCE";
                    year = 1 - year;
                }
                return new (0, _calendarDate.CalendarDate)(this, era, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var year = date.year;
                if (date.era === "BCE") year = 1 - year;
                return ceToJulianDay(COPTIC_EPOCH, year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth1(date) {
                var year = date.year;
                if (date.era === "BCE") year = 1 - year;
                return getDaysInMonth(year, date.month);
            }
        },
        {
            key: "isInverseEra",
            value: function isInverseEra(date) {
                return date.era === "BCE";
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                if (date.year <= 0) {
                    date.era = date.era === "BCE" ? "CE" : "BCE";
                    date.year = 1 - date.year;
                }
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "BCE",
                    "CE"
                ];
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                // 9999-12-30 gregorian is 9716-02-20 coptic.
                // Round down to 9715 for the last full year.
                // BCE 9999-01-01 coptic is BC 9716-06-15 gregorian.
                return date.era === "BCE" ? 9999 : 9715;
            }
        }
    ]);
    return CopticCalendar;
}(EthiopicCalendar);

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_inherits":"aYVfo","@swc/helpers/_/_sliced_to_array":"jzEiA","@swc/helpers/_/_create_super":"31igY","../CalendarDate":"bo84l","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"4c2fK":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Creates a `Calendar` instance from a Unicode calendar identifier string. */ parcelHelpers.export(exports, "createCalendar", function() {
    return createCalendar;
});
var _buddhistCalendar = require("./calendars/BuddhistCalendar");
var _ethiopicCalendar = require("./calendars/EthiopicCalendar");
var _gregorianCalendar = require("./calendars/GregorianCalendar");
var _hebrewCalendar = require("./calendars/HebrewCalendar");
var _indianCalendar = require("./calendars/IndianCalendar");
var _islamicCalendar = require("./calendars/IslamicCalendar");
var _japaneseCalendar = require("./calendars/JapaneseCalendar");
var _persianCalendar = require("./calendars/PersianCalendar");
var _taiwanCalendar = require("./calendars/TaiwanCalendar");
function createCalendar(name) {
    switch(name){
        case "buddhist":
            return new (0, _buddhistCalendar.BuddhistCalendar)();
        case "ethiopic":
            return new (0, _ethiopicCalendar.EthiopicCalendar)();
        case "ethioaa":
            return new (0, _ethiopicCalendar.EthiopicAmeteAlemCalendar)();
        case "coptic":
            return new (0, _ethiopicCalendar.CopticCalendar)();
        case "hebrew":
            return new (0, _hebrewCalendar.HebrewCalendar)();
        case "indian":
            return new (0, _indianCalendar.IndianCalendar)();
        case "islamic-civil":
            return new (0, _islamicCalendar.IslamicCivilCalendar)();
        case "islamic-tbla":
            return new (0, _islamicCalendar.IslamicTabularCalendar)();
        case "islamic-umalqura":
            return new (0, _islamicCalendar.IslamicUmalquraCalendar)();
        case "japanese":
            return new (0, _japaneseCalendar.JapaneseCalendar)();
        case "persian":
            return new (0, _persianCalendar.PersianCalendar)();
        case "roc":
            return new (0, _taiwanCalendar.TaiwanCalendar)();
        case "gregory":
        default:
            return new (0, _gregorianCalendar.GregorianCalendar)();
    }
}

},{"./calendars/BuddhistCalendar":"asUIt","./calendars/EthiopicCalendar":"b6ija","./calendars/GregorianCalendar":"CFsNw","./calendars/HebrewCalendar":"7Hw3F","./calendars/IndianCalendar":"8ghe3","./calendars/IslamicCalendar":"efTuE","./calendars/JapaneseCalendar":"9mSVu","./calendars/PersianCalendar":"a4zzG","./calendars/TaiwanCalendar":"bT8Ng","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"3lhNP":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateFormatter", function() {
    return DateFormatter;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var formatterCache = new Map();
var DateFormatter = /*#__PURE__*/ function() {
    "use strict";
    function DateFormatter(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, DateFormatter);
        this.formatter = getCachedDateFormatter(locale, options);
        this.options = options;
    }
    (0, _createClass._)(DateFormatter, [
        {
            /** Formats a date as a string according to the locale and format options passed to the constructor. */ key: "format",
            value: function format(value) {
                return this.formatter.format(value);
            }
        },
        {
            /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ key: "formatToParts",
            value: function formatToParts(value) {
                return this.formatter.formatToParts(value);
            }
        },
        {
            /** Formats a date range as a string. */ key: "formatRange",
            value: function formatRange(start, end) {
                // @ts-ignore
                if (typeof this.formatter.formatRange === "function") // @ts-ignore
                return this.formatter.formatRange(start, end);
                if (end < start) throw new RangeError("End date must be >= start date");
                // Very basic fallback for old browsers.
                return "".concat(this.formatter.format(start), " \u2013 ").concat(this.formatter.format(end));
            }
        },
        {
            /** Formats a date range as an array of parts. */ key: "formatRangeToParts",
            value: function formatRangeToParts(start, end) {
                // @ts-ignore
                if (typeof this.formatter.formatRangeToParts === "function") // @ts-ignore
                return this.formatter.formatRangeToParts(start, end);
                if (end < start) throw new RangeError("End date must be >= start date");
                var startParts = this.formatter.formatToParts(start);
                var endParts = this.formatter.formatToParts(end);
                return (0, _toConsumableArray._)(startParts.map(function(p) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                        source: "startRange"
                    });
                })).concat([
                    {
                        type: "literal",
                        value: " \u2013 ",
                        source: "shared"
                    }
                ], (0, _toConsumableArray._)(endParts.map(function(p) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                        source: "endRange"
                    });
                })));
            }
        },
        {
            /** Returns the resolved formatting options based on the values passed to the constructor. */ key: "resolvedOptions",
            value: function resolvedOptions() {
                var resolvedOptions = this.formatter.resolvedOptions();
                if (hasBuggyResolvedHourCycle()) {
                    if (!this.resolvedHourCycle) this.resolvedHourCycle = getResolvedHourCycle(resolvedOptions.locale, this.options);
                    resolvedOptions.hourCycle = this.resolvedHourCycle;
                    resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
                }
                // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
                // https://bugs.webkit.org/show_bug.cgi?id=241564
                if (resolvedOptions.calendar === "ethiopic-amete-alem") resolvedOptions.calendar = "ethioaa";
                return resolvedOptions;
            }
        }
    ]);
    return DateFormatter;
}();
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
var hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: "h11"
    },
    false: {
    }
};
function getCachedDateFormatter(locale) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === "boolean" && hasBuggyHour12Behavior()) {
        options = (0, _objectSpread._)({}, options);
        var pref = hour12Preferences[String(options.hour12)][locale.split("-")[0]];
        var defaultHourCycle = options.hour12 ? "h12" : "h23";
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : "");
    if (formatterCache.has(cacheKey)) return formatterCache.get(cacheKey);
    var numberFormatter = new Intl.DateTimeFormat(locale, options);
    formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
var _hasBuggyHour12Behavior = null;
function hasBuggyHour12Behavior() {
    if (_hasBuggyHour12Behavior == null) _hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
    return _hasBuggyHour12Behavior;
}
var _hasBuggyResolvedHourCycle = null;
function hasBuggyResolvedHourCycle() {
    if (_hasBuggyResolvedHourCycle == null) _hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
        hour: "numeric",
        hour12: false
    }).resolvedOptions().hourCycle === "h12";
    return _hasBuggyResolvedHourCycle;
}
function getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
    locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
    var formatter = getCachedDateFormatter(locale, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        timeZone: undefined // use local timezone
    }));
    var min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find(function(p) {
        return p.type === "hour";
    }).value, 10);
    var max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find(function(p) {
        return p.type === "hour";
    }).value, 10);
    if (min === 0 && max === 23) return "h23";
    if (min === 24 && max === 23) return "h24";
    if (min === 0 && max === 11) return "h11";
    if (min === 12 && max === 11) return "h12";
    throw new Error("Unexpected hour cycle result");
}

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_to_consumable_array":"4Hwej","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"cArRR":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized number formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the number formatter for performance.
 * @param options - Formatting options.
 */ parcelHelpers.export(exports, "useNumberFormatter", function() {
    return useNumberFormatter;
});
var _number = require("@internationalized/number");
var _context = require("./context");
var _react = require("react");
function useNumberFormatter() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var locale = (0, _context.useLocale)().locale;
    return (0, _react.useMemo)(function() {
        return new (0, _number.NumberFormatter)(locale, options);
    }, [
        locale,
        options
    ]);
}

},{"@internationalized/number":"btFvL","./context":"6aOvd","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"btFvL":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberFormatter", function() {
    return 0, _numberFormatter.NumberFormatter;
});
parcelHelpers.export(exports, "NumberParser", function() {
    return 0, _numberParser.NumberParser;
});
var _numberFormatter = require("./NumberFormatter");
var _numberParser = require("./NumberParser");

},{"./NumberFormatter":"aaD4R","./NumberParser":"jIqoX","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"aaD4R":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberFormatter", function() {
    return NumberFormatter;
});
/** @private - exported for tests */ parcelHelpers.export(exports, "numberFormatSignDisplayPolyfill", function() {
    return numberFormatSignDisplayPolyfill;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var formatterCache = new Map();
var supportsSignDisplay = false;
try {
    // @ts-ignore
    supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
var supportsUnit = false;
try {
    // @ts-ignore
    supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
var UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " \u5EA6",
            "zh-TW": "\u5EA6",
            "sl-SI": " \xb0"
        }
    }
};
var NumberFormatter = /*#__PURE__*/ function() {
    "use strict";
    function NumberFormatter(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, NumberFormatter);
        this.numberFormatter = getCachedNumberFormatter(locale, options);
        this.options = options;
    }
    (0, _createClass._)(NumberFormatter, [
        {
            /** Formats a number value as a string, according to the locale and options provided to the constructor. */ key: "format",
            value: function format(value) {
                var res = "";
                if (!supportsSignDisplay && this.options.signDisplay != null) res = numberFormatSignDisplayPolyfill(this.numberFormatter, this.options.signDisplay, value);
                else res = this.numberFormatter.format(value);
                if (this.options.style === "unit" && !supportsUnit) {
                    var _UNITS_unit;
                    var _this_resolvedOptions = this.resolvedOptions(), unit = _this_resolvedOptions.unit, _this_resolvedOptions_unitDisplay = _this_resolvedOptions.unitDisplay, unitDisplay = _this_resolvedOptions_unitDisplay === void 0 ? "short" : _this_resolvedOptions_unitDisplay, locale = _this_resolvedOptions.locale;
                    if (!unit) return res;
                    var values = (_UNITS_unit = UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
                    res += values[locale] || values.default;
                }
                return res;
            }
        },
        {
            /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ key: "formatToParts",
            value: function formatToParts(value) {
                // TODO: implement signDisplay for formatToParts
                // @ts-ignore
                return this.numberFormatter.formatToParts(value);
            }
        },
        {
            /** Formats a number range as a string. */ key: "formatRange",
            value: function formatRange(start, end) {
                // @ts-ignore
                if (typeof this.numberFormatter.formatRange === "function") // @ts-ignore
                return this.numberFormatter.formatRange(start, end);
                if (end < start) throw new RangeError("End date must be >= start date");
                // Very basic fallback for old browsers.
                return "".concat(this.format(start), " \u2013 ").concat(this.format(end));
            }
        },
        {
            /** Formats a number range as an array of parts. */ key: "formatRangeToParts",
            value: function formatRangeToParts(start, end) {
                // @ts-ignore
                if (typeof this.numberFormatter.formatRangeToParts === "function") // @ts-ignore
                return this.numberFormatter.formatRangeToParts(start, end);
                if (end < start) throw new RangeError("End date must be >= start date");
                var startParts = this.numberFormatter.formatToParts(start);
                var endParts = this.numberFormatter.formatToParts(end);
                return (0, _toConsumableArray._)(startParts.map(function(p) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                        source: "startRange"
                    });
                })).concat([
                    {
                        type: "literal",
                        value: " \u2013 ",
                        source: "shared"
                    }
                ], (0, _toConsumableArray._)(endParts.map(function(p) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                        source: "endRange"
                    });
                })));
            }
        },
        {
            /** Returns the resolved formatting options based on the values passed to the constructor. */ key: "resolvedOptions",
            value: function resolvedOptions() {
                var options = this.numberFormatter.resolvedOptions();
                if (!supportsSignDisplay && this.options.signDisplay != null) options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    signDisplay: this.options.signDisplay
                });
                if (!supportsUnit && this.options.style === "unit") options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    style: "unit",
                    unit: this.options.unit,
                    unitDisplay: this.options.unitDisplay
                });
                return options;
            }
        }
    ]);
    return NumberFormatter;
}();
function getCachedNumberFormatter(locale) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var numberingSystem = options.numberingSystem;
    if (numberingSystem && locale.includes("-nu-")) {
        if (!locale.includes("-u-")) locale += "-u-";
        locale += "-nu-".concat(numberingSystem);
    }
    if (options.style === "unit" && !supportsUnit) {
        var _UNITS_unit;
        var unit = options.unit, _options_unitDisplay = options.unitDisplay, unitDisplay = _options_unitDisplay === void 0 ? "short" : _options_unitDisplay;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error("Unsupported unit ".concat(unit, " with unitDisplay = ").concat(unitDisplay));
        options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            style: "decimal"
        });
    }
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : "");
    if (formatterCache.has(cacheKey)) return formatterCache.get(cacheKey);
    var numberFormatter = new Intl.NumberFormat(locale, options);
    formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function numberFormatSignDisplayPolyfill(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        var needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            var negative = numberFormat.format(-num);
            var noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            var minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ((0, _toConsumableArray._)(minus).length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            var positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_to_consumable_array":"4Hwej","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"jIqoX":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberParser", function() {
    return NumberParser;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _numberFormatter = require("./NumberFormatter");
var CURRENCY_SIGN_REGEX = new RegExp("^.*\\(.*\\).*$");
var NUMBERING_SYSTEMS = [
    "latn",
    "arab",
    "hanidec"
];
var NumberParser = /*#__PURE__*/ function() {
    "use strict";
    function NumberParser(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, NumberParser);
        this.locale = locale;
        this.options = options;
    }
    (0, _createClass._)(NumberParser, [
        {
            /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ key: "parse",
            value: function parse(value) {
                return getNumberParserImpl(this.locale, this.options, value).parse(value);
            }
        },
        {
            /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ key: "isValidPartialNumber",
            value: function isValidPartialNumber(value, minValue, maxValue) {
                return getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
            }
        },
        {
            /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ key: "getNumberingSystem",
            value: function getNumberingSystem(value) {
                return getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
            }
        }
    ]);
    return NumberParser;
}();
var numberParserCache = new Map();
function getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    var defaultParser = getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes("-nu-") && !defaultParser.isValidPartialNumber(value)) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = NUMBERING_SYSTEMS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var numberingSystem = _step.value;
                if (numberingSystem !== defaultParser.options.numberingSystem) {
                    var parser = getCachedNumberParser(locale + (locale.includes("-u-") ? "-nu-" : "-u-nu-") + numberingSystem, options);
                    if (parser.isValidPartialNumber(value)) return parser;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return defaultParser;
}
function getCachedNumberParser(locale, options) {
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : "");
    var parser = numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new NumberParserImpl(locale, options);
        numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
var NumberParserImpl = /*#__PURE__*/ function() {
    "use strict";
    function NumberParserImpl(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, NumberParserImpl);
        this.locale = locale;
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = getSymbols(locale, this.formatter, this.options, options);
        var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
        if (this.options.style === "percent" && (((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) > 18 || ((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) > 18)) console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
    }
    (0, _createClass._)(NumberParserImpl, [
        {
            key: "parse",
            value: function parse(value) {
                // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
                var fullySanitizedValue = this.sanitize(value);
                if (this.symbols.group) // Remove group characters, and replace decimal points and numerals with ASCII values.
                fullySanitizedValue = replaceAll(fullySanitizedValue, this.symbols.group, "");
                if (this.symbols.decimal) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.decimal, ".");
                if (this.symbols.minusSign) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.minusSign, "-");
                fullySanitizedValue = fullySanitizedValue.replace(this.symbols.numeral, this.symbols.index);
                if (this.options.style === "percent") {
                    // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
                    var isNegative = fullySanitizedValue.indexOf("-");
                    fullySanitizedValue = fullySanitizedValue.replace("-", "");
                    var index = fullySanitizedValue.indexOf(".");
                    if (index === -1) index = fullySanitizedValue.length;
                    fullySanitizedValue = fullySanitizedValue.replace(".", "");
                    if (index - 2 === 0) fullySanitizedValue = "0.".concat(fullySanitizedValue);
                    else if (index - 2 === -1) fullySanitizedValue = "0.0".concat(fullySanitizedValue);
                    else if (index - 2 === -2) fullySanitizedValue = "0.00";
                    else fullySanitizedValue = "".concat(fullySanitizedValue.slice(0, index - 2), ".").concat(fullySanitizedValue.slice(index - 2));
                    if (isNegative > -1) fullySanitizedValue = "-".concat(fullySanitizedValue);
                }
                var newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
                if (isNaN(newValue)) return NaN;
                if (this.options.style === "percent") {
                    // extra step for rounding percents to what our formatter would output
                    var options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.options), {
                        style: "decimal",
                        minimumFractionDigits: Math.min(this.options.minimumFractionDigits + 2, 20),
                        maximumFractionDigits: Math.min(this.options.maximumFractionDigits + 2, 20)
                    });
                    return new NumberParser(this.locale, options).parse(new (0, _numberFormatter.NumberFormatter)(this.locale, options).format(newValue));
                }
                // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
                if (this.options.currencySign === "accounting" && CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
                return newValue;
            }
        },
        {
            key: "sanitize",
            value: function sanitize(value) {
                // Remove literals and whitespace, which are allowed anywhere in the string
                value = value.replace(this.symbols.literals, "");
                // Replace the ASCII minus sign with the minus sign used in the current locale
                // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
                if (this.symbols.minusSign) value = value.replace("-", this.symbols.minusSign);
                // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
                // instead they use the , (44) character or apparently the (1548) character.
                if (this.options.numberingSystem === "arab") {
                    if (this.symbols.decimal) {
                        value = value.replace(",", this.symbols.decimal);
                        value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
                    }
                    if (this.symbols.group) value = replaceAll(value, ".", this.symbols.group);
                }
                // fr-FR group character is char code 8239, but that's not a key on the french keyboard,
                // so allow 'period' as a group char and replace it with a space
                if (this.options.locale === "fr-FR") value = replaceAll(value, ".", String.fromCharCode(8239));
                return value;
            }
        },
        {
            key: "isValidPartialNumber",
            value: function isValidPartialNumber(value) {
                var minValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -Infinity, maxValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
                value = this.sanitize(value);
                // Remove minus or plus sign, which must be at the start of the string.
                if (this.symbols.minusSign && value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
                else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
                // Numbers cannot start with a group separator
                if (this.symbols.group && value.startsWith(this.symbols.group)) return false;
                // Numbers that can't have any decimal values fail if a decimal character is typed
                if (this.symbols.decimal && value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
                // Remove numerals, groups, and decimals
                if (this.symbols.group) value = replaceAll(value, this.symbols.group, "");
                value = value.replace(this.symbols.numeral, "");
                if (this.symbols.decimal) value = value.replace(this.symbols.decimal, "");
                // The number is valid if there are no remaining characters
                return value.length === 0;
            }
        }
    ]);
    return NumberParserImpl;
}();
var nonLiteralParts = new Set([
    "decimal",
    "fraction",
    "integer",
    "minusSign",
    "plusSign",
    "group"
]);
// This list is derived from https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// See: https://github.com/adobe/react-spectrum/pull/5134/files#r1337037855 for used script
var pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function getSymbols(locale, formatter, intlOptions, originalOptions) {
    var _allParts_find, _posAllParts_find, _decimalParts_find, _allParts_find1;
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    var symbolFormatter = new Intl.NumberFormat(locale, (0, _objectSpreadProps._)((0, _objectSpread._)({}, intlOptions), {
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21
    }));
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    var allParts = symbolFormatter.formatToParts(-10000.111);
    var posAllParts = symbolFormatter.formatToParts(10000.111);
    var pluralParts = pluralNumbers.map(function(n) {
        return symbolFormatter.formatToParts(n);
    });
    var _allParts_find_value;
    var minusSign = (_allParts_find_value = (_allParts_find = allParts.find(function(p) {
        return p.type === "minusSign";
    })) === null || _allParts_find === void 0 ? void 0 : _allParts_find.value) !== null && _allParts_find_value !== void 0 ? _allParts_find_value : "-";
    var plusSign = (_posAllParts_find = posAllParts.find(function(p) {
        return p.type === "plusSign";
    })) === null || _posAllParts_find === void 0 ? void 0 : _posAllParts_find.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    // @ts-ignore
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "exceptZero" || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "always")) plusSign = "+";
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    var decimalParts = new Intl.NumberFormat(locale, (0, _objectSpreadProps._)((0, _objectSpread._)({}, intlOptions), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })).formatToParts(0.001);
    var decimal = (_decimalParts_find = decimalParts.find(function(p) {
        return p.type === "decimal";
    })) === null || _decimalParts_find === void 0 ? void 0 : _decimalParts_find.value;
    var group = (_allParts_find1 = allParts.find(function(p) {
        return p.type === "group";
    })) === null || _allParts_find1 === void 0 ? void 0 : _allParts_find1.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    var allPartsLiterals = allParts.filter(function(p) {
        return !nonLiteralParts.has(p.type);
    }).map(function(p) {
        return escapeRegex(p.value);
    });
    var pluralPartsLiterals = pluralParts.flatMap(function(p) {
        return p.filter(function(p) {
            return !nonLiteralParts.has(p.type);
        }).map(function(p) {
            return escapeRegex(p.value);
        });
    });
    var sortedLiterals = (0, _toConsumableArray._)(new Set((0, _toConsumableArray._)(allPartsLiterals).concat((0, _toConsumableArray._)(pluralPartsLiterals)))).sort(function(a, b) {
        return b.length - a.length;
    });
    var literals = sortedLiterals.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp("".concat(sortedLiterals.join("|"), "|[\\p{White_Space}]"), "gu");
    // These are for replacing non-latn characters with the latn equivalent
    var numerals = (0, _toConsumableArray._)(new Intl.NumberFormat(intlOptions.locale, {
        useGrouping: false
    }).format(9876543210)).reverse();
    var indexes = new Map(numerals.map(function(d, i) {
        return [
            d,
            i
        ];
    }));
    var numeral = new RegExp("[".concat(numerals.join(""), "]"), "g");
    var index = function(d) {
        return String(indexes.get(d));
    };
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        index: index
    };
}
function replaceAll(str, find, replace) {
    // @ts-ignore
    if (str.replaceAll) // @ts-ignore
    return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

},{"@swc/helpers/_/_class_call_check":"4Bbsg","@swc/helpers/_/_create_class":"bRwSx","@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_to_consumable_array":"4Hwej","./NumberFormatter":"aaD4R","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"bKAkm":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized string collation for the current locale. Automatically updates when the locale changes,
 * and handles caching of the collator for performance.
 * @param options - Collator options.
 */ parcelHelpers.export(exports, "useCollator", function() {
    return useCollator;
});
var _context = require("./context");
var cache = new Map();
function useCollator(options) {
    var locale = (0, _context.useLocale)().locale;
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : "");
    if (cache.has(cacheKey)) return cache.get(cacheKey);
    var formatter = new Intl.Collator(locale, options);
    cache.set(cacheKey, formatter);
    return formatter;
}

},{"./context":"6aOvd","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"b21qn":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized string search functionality that is useful for filtering or matching items
 * in a list. Options can be provided to adjust the sensitivity to case, diacritics, and other parameters.
 */ parcelHelpers.export(exports, "useFilter", function() {
    return useFilter;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _react = require("react");
var _useCollator = require("./useCollator");
function useFilter(options) {
    var collator = (0, _useCollator.useCollator)((0, _objectSpread._)({
        usage: "search"
    }, options));
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    var startsWith = (0, _react.useCallback)(function(string, substring) {
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    var endsWith = (0, _react.useCallback)(function(string, substring) {
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    var contains = (0, _react.useCallback)(function(string, substring) {
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        var scan = 0;
        var sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            var slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, _react.useMemo)(function() {
        return {
            startsWith: startsWith,
            endsWith: endsWith,
            contains: contains
        };
    }, [
        startsWith,
        endsWith,
        contains
    ]);
}

},{"@swc/helpers/_/_object_spread":"96NPP","react":"lbBKc","./useCollator":"bKAkm","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=useCalendar.stories.57b4dcb2.js.map
